import { useParams } from "react-router-dom";
import React, { useRef, useEffect, useState } from "react";
import { useLogo } from "../context/LogoContext";

import ecommercebannerphoto from "../Assets/e-commerc.jpg";
import websitephoto from "../Assets/gratitude-home.png";
import websitephoto2 from "../Assets/gratitude-products-section-filtered.png";
import websitephoto3 from "../Assets/gratitude-view-products-filtered.png";
import Heading from "../reusable-components/fonts/Heading";
import SubHeading from "../reusable-components/fonts/SubHeading";
import egovbannerphoto from "../Assets/rsbbanner.png";
import dashboardSikkimTourism from "../Assets/dashboradSikkimTourism.jpeg";
import dataprofiling from "../Assets/dataProfiling.jpeg";
import servicerReg from "../Assets/servicerReg.jpeg";
import registrationForm from "../Assets/serviceRegistration.jpeg";
import travelcardpage from "../Assets/TravelCard.jpeg";
import travelcard from "../Assets/travelCard2.jpeg";
import tourismLogin from "../Assets/tourism_login.png";
import bankingbannerphoto from "../Assets/bankingrandom.jpg";
import websitephotosabcco from "../Assets/sabccohome.png";
import communitybannerphoto from "../Assets/seedcell.png";
import websitephotoseed from "../Assets/seedhome.png";
import websitephotosis from "../Assets/sishome.png";
import websitephotosicun from "../Assets/sicunhome.png";
import GenericModal from "../reusable-components/modal/GenericModal";
import websitephotosisco from "../Assets/siscohome.png";
import bankingbannerphoto2 from "../Assets/BankingBanner.jpg";
import checkrates from "../Assets/checkRates_sisco.png";
import findatm from "../Assets/findatm_sisco.png";
import loans from "../Assets/loans_sisco.png";
import hrms from "../Assets/hrms.png";
import mitra_app from "../Assets/mitra_app.png";
import googleplay from "../Assets/googleplay.png";
import mitraBanner from "../Assets/milk.jpg";
import mitra_Banner from "../Assets/MitraWebBanner.PNG";
import login from "../Assets/login_mitraApp.png";
import billing from "../Assets/billing_mitraApp.png";
import orders from "../Assets/orders_mitraApp.png";
import appImage from "../Assets/app-imag-1.png";
import appImage2 from "../Assets/app-imag-4.png";
import appImage4 from "../Assets/app-imag-2.png";
import appImage3 from "../Assets/app-imag-5.png";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import dashboardHRMS from "../Assets/SMUHRMSDashboard.jpeg";
import configHRMS from "../Assets/HRMSConfig.jpeg";
import SmuHrms1 from "../Assets/SmuHrms_1.PNG";
import SmuHrms2 from "../Assets/SmuHrms_2.PNG";
import SmuHrms3 from "../Assets/SmuHrms_3.PNG";
import SmuHrms4 from "../Assets/SmuHrms_4.PNG";
import dairybannerphoto from "../Assets/pnibanner.jpg";
import projecthomephoto from "../Assets/pnihome.png";
import projectfirstphoto from "../Assets/pnifirst.png";
import projectsecondphoto from "../Assets/pnisecond.png";
import websitephotosec from "../Assets/sechome.png";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import tourism_banner from "../Assets/tour.jpg";
import stnmInventorySS1 from "../Assets/stnmi1.png";
import stnmInventorySS2 from "../Assets/stnmi2.png";
import sicunBanner from "../Assets/sicunBanner.jpg";
import sicunEstore from "../Assets/sicunEstore.png";
import sicunEstoreBanner from "../Assets/sicunEstoreBanner.jpg";
import sicSS from "../Assets/ProjectCardScreenshots/sichome.png";
import sicBanner from "../Assets/sicBanner.jpg";
import stnmComplaintSS from "../Assets/ProjectCardScreenshots/stnmComplaint.png";
import stnmCmsBannerPhoto from "../Assets/stnmCmsBanner.jpg";
import stnmSS from "../Assets/ProjectCardScreenshots/stnmHome.png";
import stnmBanner from "../Assets/stnmBanner.jpg";
import SikkimTourismBanner from "../Assets/sikkimTourismBanner.jpg";
import aashitatSS from "../Assets/ProjectCardScreenshots/aashitat_home.jpeg";
import ashiBannerPhoto from "../Assets/ashiBannerPhoto.jpg";
import logoWordpress from "../Assets/logoWordpress.png";
import logoElementor from "../Assets/logoElementor.png";
import eaglesNestSS from "../Assets/ProjectCardScreenshots/eaglesnesthome.PNG";
import eaglesNestBannerPhoto from "../Assets/eagleNestBannerPhoto.jpg";
import nitSS from "../Assets/ProjectCardScreenshots/nit_home.jpeg";
import nitBanner from "../Assets/nitBanner.jpg";
import panchakSS from "../Assets/ProjectCardScreenshots/PanchakWebsiteHome.PNG";
import panchakBanner from "../Assets/panchakBanner.webp";
import rsbSS from "../Assets/ProjectCardScreenshots/RSBWebsiteHomeIMG.png";
import kuber1 from "../Assets/ProjectCardScreenshots/kuber3.png";
import kuber2 from "../Assets/ProjectCardScreenshots/kuber2.png";

import logoAspnet from "../Assets/logoAspnet.png";
import logoBootstrap from "../Assets/logoBootstrap.png";
import logoMsSql from "../Assets/logoMsSql.png";
import logoNodejs from "../Assets/logoNodejs.png";
import logoPgsql from "../Assets/logoPgsql.png";
import logoReactjs from "../Assets/logoReactjs.png";
import logoStrapi from "../Assets/logoStrapi.png";
import logoTailwind from "../Assets/logoTailwind.png";
import logoExpressjs from "../Assets/expressJS.webp";

const ProjectDescription = () => {
  const { projectName } = useParams();

  return (
    <div className="font-poppins">
      {projectName === "gratitude" && <ProjectGratitude />}
      {projectName === "rsb" && <ProjectRsb />}
      {projectName === "sikkim-tourism" && <ProjectSikkimTourism />}
      {projectName === "sabcco" && <ProjectSabcco />}
      {projectName === "seed-cell" && <ProjectSeedCell />}
      {projectName === "sicun" && <ProjectSicun />}
      {projectName === "sis" && <ProjectSikkimInvestmentSummit />}
      {projectName === "sisco" && <ProjectSiscoBank />}
      {projectName === "sikkim-milk-hrms" && <ProjectSikkimMilkHRMS />}
      {projectName === "sikkim-milk-mitra" && <ProjectSikkimMilkMitraApp />}
      {projectName === "sikkim-milk-pni" && <ProjectSmuPni />}
      {projectName === "sec" && <ProjectSecSikkim />}
      {projectName === "stnm" && <ProjectStnm />}
      {projectName === "stnm-cms" && <ProjectStnmCms />}
      {projectName === "sic" && <ProjectSikkimInfoCommission />}
      {projectName === "stnm-ims" && <ProjectStnmInventory />}
      {projectName === "sicun-estore" && <ProjectSicunEstore />}
      {projectName === "ashi" && <ProjectAshiTours />}
      {projectName === "eagles-nest" && <ProjectEaglesNestGangtok />}
      {projectName === "nit" && <ProjectNit />}
      {projectName === "panchak" && <ProjectPanchak />}
      {projectName === "kuber-world" && <ProjectKuberWorld />}
    </div>
  );
};

export default ProjectDescription;

const ProjectKuberWorld = () => {
  const bannerRef = useRef();

  const { setFirstDivHeight } = useLogo();

  useEffect(() => {
    if (bannerRef?.current?.offsetHeight > 0) {
      setFirstDivHeight(bannerRef?.current?.offsetHeight);
    }
  }, [bannerRef?.current?.offsetHeight]);

  return (
    <>
      <div>
        <section className="pb-24 lg:pb-36">
          <div className="relative" ref={bannerRef}>
            <div className="bg-black opacity-70 h-72 lg:h-[500px] w-full object-cover absolute"></div>
            <img
              src={kuber1}
              alt="Kuber World Banner"
              className="h-72 lg:h-[500px] w-full object-cover"
            />
            <div className="absolute top-1/2 left-10 -translate-y-1/2">
              <Heading classes="text-white">Kuber World</Heading>
              <p className="text-white font-medium text-xl lg:text-2xl">
                e-Finance Management System
              </p>
            </div>
          </div>

          <div className="flex justify-end">
            <a
              href="/our-projects"
              className="text-white text-sm bg-primary px-4 py-2 cursor-pointer hover:underline"
            >
              View All Projects
            </a>
          </div>

          <div className="w-[80%] mx-auto">
            <div className="md:relative flex flex-col md:flex-row justify-center items-center">
              <Heading
                classes={`mt-10 mb-5 flex justify-center font-medium text-gray-800`}
              >
                Kuber World e-Finance Software
              </Heading>
            </div>

            <div className="mt-10 lg:mt-16 mb-5 lg:mb-10 grid grid-cols-1 lg:grid-cols-2">
              <div className="text-xs lg:text-base 2xl:text-[20px] font-normal mb-10 lg:mb-0 lg:pr-8 text-justify">
                <p className="leading-relaxed text-gray-700">
                  Kuber World e-Finance is a powerful micro-finance software
                  built for efficient loan and recurring deposit management.
                  Designed with modern financial institutions in mind, this
                  system streamlines the handling of loan disbursements, EMI
                  collections, borrower profiling, and recurring deposit
                  tracking—all through a seamless digital interface.
                  <br />
                  <br />
                  The platform automates daily transactions, ensuring accuracy,
                  speed, and financial transparency. It includes user management
                  modules for agents, admin users, and borrowers, enabling
                  role-based access to different functionalities. The reporting
                  system allows admins to track outstanding loans, payment
                  schedules, defaulters, and detailed RD summaries.
                  <br />
                  <br />
                  With an intuitive dashboard, automated notifications, and
                  secure data handling, Kuber World empowers micro-finance
                  operations with real-time insights and control over financial
                  workflows.
                </p>
              </div>

              <div className="flex flex-col">
                <div className="relative flex justify-end shadow-2xl">
                  <img
                    src={kuber2}
                    className="rounded-md h-full"
                    alt="Kuber World Screenshot"
                  />
                </div>
              </div>
            </div>

            <SubHeading classes={`mt-16 lg:mt-28 mb-5 lg:mb-10 text-gray-800`}>
              Key Features
            </SubHeading>
            <div className="mb-10">
              <ul className="list-disc font-normal text-xs lg:text-base 2xl:text-[20px] mx-10 text-justify text-gray-700">
                <li className="mb-4">
                  Loan disbursement and EMI collection tracking.
                </li>
                <li className="mb-4">
                  Recurring deposit management with automated maturity
                  calculations.
                </li>
                <li className="mb-4">
                  Real-time dashboards for admins and agents.
                </li>
                <li className="mb-4">
                  User and role management system for access control.
                </li>
                {/* <li className="mb-4">
                  Auto-generated reports for payments, defaulters, interest, and
                  more.
                </li>
                <li className="mb-4">
                  Built-in SMS/email notifications for transactions and
                  reminders.
                </li> */}
              </ul>
            </div>

            <SubHeading classes={`mt-16 lg:mt-28 mb-5 lg:mb-10 text-gray-800`}>
              Technology Used
            </SubHeading>
            <div className="flex flex-row items-center gap-10 lg:gap-16 justify-start">
              <div className="flex flex-col items-center">
                <img
                  src={logoReactjs}
                  alt="React JS"
                  className="h-12 lg:h-20 object-contain mx-auto"
                  style={{
                    animation: "spin 20s linear infinite",
                  }}
                />
                <p className="mt-2 text-xs lg:text-sm text-center text-gray-700">
                  React JS
                </p>
              </div>
              <div className="flex flex-col items-center">
                <img
                  src={logoNodejs}
                  alt="Node JS"
                  className="h-12 lg:h-20 object-contain"
                />
                <p className="mt-2 text-xs lg:text-sm text-center text-gray-700">
                  Node JS
                </p>
              </div>
              <div className="flex flex-col items-center">
                <img
                  src={logoExpressjs}
                  alt="Node JS"
                  className="h-12 lg:h-20 object-contain"
                />
                <p className="mt-2 text-xs lg:text-sm text-center text-gray-700">
                  Express JS
                </p>
              </div>
              <div className="flex flex-col items-center">
                <img
                  src={logoPgsql}
                  alt="PostgreSQL"
                  className="h-12 lg:h-20 object-contain"
                />
                <p className="mt-2 text-xs lg:text-sm text-center text-gray-700">
                  PostgreSQL
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

const ProjectPanchak = () => {
  const bannerRef = useRef();

  const { setFirstDivHeight } = useLogo();

  useEffect(() => {
    if (bannerRef?.current?.offsetHeight > 0) {
      setFirstDivHeight(bannerRef?.current?.offsetHeight);
    }
  }, [bannerRef?.current?.offsetHeight]);

  return (
    <>
      <div>
        <section className="pb-24 lg:pb-36">
          <div className="relative" ref={bannerRef}>
            <div className="bg-black opacity-70 h-72 lg:h-[500px] w-full object-cover absolute"></div>
            <img
              src={panchakBanner}
              alt="Panchak Holidays Banner"
              className="h-72 lg:h-[500px] w-full object-cover"
            />
            <div className="absolute top-1/2 left-10 -translate-y-1/2">
              <Heading classes={`text-white`}>Panchak Holidays</Heading>
              <p className="text-white font-medium text-xl lg:text-2xl">
                Official Website
              </p>
            </div>
          </div>

          <div className="flex justify-end">
            <a
              href="/our-projects"
              className="text-white text-sm bg-primary px-4 py-2 cursor-pointer hover:underline"
            >
              View All Projects
            </a>
          </div>

          <div className="w-[80%] mx-auto">
            <div className="md:relative flex flex-col md:flex-row justify-center items-center">
              <a
                href="https://panchakholidays.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Heading classes="mt-10 mb-5 flex justify-center font-medium text-gray-800">
                  Panchak Holidays Website
                </Heading>
              </a>
            </div>

            <div className="mt-10 lg:mt-16 mb-5 lg:mb-10 grid grid-cols-1 lg:grid-cols-2">
              <div className="text-xs lg:text-base 2xl:text-[20px] font-normal mb-10 lg:mb-0 lg:pr-8 text-justify">
                <p className="leading-relaxed text-gray-700">
                  Panchak Holidays is a premier travel and tour operator based
                  in Sikkim, offering tailor-made tour experiences across the
                  Northeast region of India and beyond. Their official website
                  serves as a digital gateway for both domestic and
                  international travelers seeking adventure, culture, and serene
                  getaways.
                  <br />
                  <br />
                  The website provides comprehensive information about curated
                  tour packages, hotel bookings, car rentals, adventure trips,
                  pilgrimage tours, and eco-tourism options. From family
                  vacations to trekking expeditions and honeymoon packages, the
                  platform is built to assist travelers at every step—from
                  planning to execution.
                  <br />
                  <br />
                  With high-quality visuals, a modern layout, and intuitive
                  navigation, the site ensures visitors can explore travel
                  destinations, get instant quotes, and make inquiries
                  seamlessly. It also features testimonials, gallery sections,
                  and seasonal offer highlights to build trust and engagement.
                </p>
              </div>

              <div className="flex flex-col">
                <div className="relative flex justify-end shadow-2xl">
                  <img
                    src={panchakSS}
                    className="rounded-md h-full"
                    alt="Panchak Holidays Website"
                  />
                  <a
                    href="https://panchakholidays.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="absolute bottom-4 right-6 bg-[#E75124] text-white cursor-pointer px-2 md:px-4 py-1 text-[10px] md:text-sm"
                  >
                    Visit site
                  </a>
                </div>
              </div>
            </div>

            <SubHeading classes={`mt-16 lg:mt-28 mb-5 lg:mb-10 text-gray-800`}>
              Key Features
            </SubHeading>
            <div className="mb-10">
              <ul className="list-disc font-normal text-xs lg:text-base 2xl:text-[20px] mx-10 text-justify text-gray-700">
                <li className="mb-4">
                  Detailed tour packages for North East India with customizable
                  options.
                </li>
                <li className="mb-4">
                  Integrated booking inquiry system for fast and efficient
                  travel planning.
                </li>
                <li className="mb-4">
                  Car rentals and hotel bookings directly accessible from the
                  website.
                </li>
                <li className="mb-4">
                  Informative travel blogs, itineraries, and seasonal offers for
                  better engagement.
                </li>
                <li className="mb-4">
                  Fully responsive design with SEO-optimized content and
                  visuals.
                </li>
              </ul>
            </div>

            <SubHeading classes={`mt-16 lg:mt-28 mb-5 lg:mb-10 text-gray-800`}>
              Technology Used
            </SubHeading>
            <div className="flex flex-row items-center gap-10 lg:gap-16 justify-start">
              <div className="flex flex-col items-center w-[85px] lg:w-40 xl:w-44">
                <img
                  src={logoWordpress}
                  alt="WordPress"
                  className="h-12 lg:h-20 object-contain mx-auto"
                />
                <p className="mt-2 text-xs lg:text-sm text-center text-gray-700">
                  WordPress
                </p>
              </div>
              <div className="flex flex-col items-center w-[85px] lg:w-40 xl:w-44">
                <img
                  src={logoElementor}
                  alt="Elementor"
                  className="h-12 lg:h-20 object-contain mx-auto"
                />
                <p className="mt-2 text-xs lg:text-sm text-center text-gray-700">
                  Elementor
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

const ProjectNit = () => {
  const bannerNitRef = useRef();

  const { setFirstDivHeight } = useLogo();

  useEffect(() => {
    if (bannerNitRef?.current?.offsetHeight > 0) {
      setFirstDivHeight(bannerNitRef?.current?.offsetHeight);
    }
  }, [bannerNitRef?.current?.offsetHeight]);

  return (
    <>
      <div>
        <section className="pb-24 lg:pb-36">
          <div className="relative" ref={bannerNitRef}>
            <div className="bg-black opacity-70 h-72 lg:h-[500px] w-full object-cover absolute"></div>
            <img
              src={nitBanner}
              alt="Namgyal Institute of Tibetology Banner"
              className="h-72 lg:h-[500px] w-full object-cover"
            />
            <div className="absolute top-1/2 left-10 -translate-y-1/2">
              <Heading classes={`text-white`}>
                Namgyal Institute of Tibetology
              </Heading>
              <p className="text-white font-medium text-xl lg:text-2xl">
                Official Website
              </p>
            </div>
          </div>

          <div className="flex justify-end">
            <a
              href="/our-projects"
              className="text-white text-sm bg-primary px-4 py-2 cursor-pointer hover:underline"
            >
              View All Projects
            </a>
          </div>

          <div className="w-[80%] mx-auto">
            <div className="md:relative flex flex-col md:flex-row justify-center items-center">
              <a
                href="https://namgyalinstitutesikkim.org"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Heading classes="mt-10 mb-5 flex justify-center font-medium text-gray-800">
                  Namgyal Institute of Tibetology
                </Heading>
              </a>
            </div>

            <div className="mt-10 lg:mt-16 mb-5 lg:mb-10 grid grid-cols-1 lg:grid-cols-2">
              <div className="text-xs lg:text-base 2xl:text-[20px] font-normal mb-10 lg:mb-0 lg:pr-8 text-justify">
                <p className="leading-relaxed text-gray-700">
                  The Namgyal Institute of Tibetology (NIT), located in Gangtok,
                  Sikkim, is a renowned center for Tibetan and Buddhist studies.
                  This official website serves as a digital extension of NIT’s
                  mission—preserving, promoting, and showcasing Tibetan culture,
                  religion, art, and language.
                  <br />
                  <br />
                  Visitors to the website can explore detailed information about
                  the Institute’s history, objectives, departments, and its
                  world-famous museum and library. Users can access academic
                  publications, event notifications, image galleries, and
                  research archives that reflect NIT's role as a premier
                  academic hub.
                  <br />
                  <br />
                  The site also provides updates on seminars, fellowships,
                  international collaborations, and visiting scholars. It aims
                  to enhance accessibility to rare manuscripts, digital
                  collections, and institutional insights for researchers and
                  enthusiasts globally.
                </p>
              </div>

              <div className="flex flex-col">
                <div className="relative flex justify-end shadow-2xl">
                  <img
                    src={nitSS}
                    className="rounded-md h-full"
                    alt="Namgyal Institute of Tibetology Website"
                  />
                  <a
                    href="https://namgyalinstitutesikkim.org/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="absolute bottom-4 right-6 bg-[#E75124] text-white cursor-pointer px-2 md:px-4 py-1 text-[10px] md:text-sm"
                  >
                    Visit site
                  </a>
                </div>
              </div>
            </div>

            <SubHeading classes={`mt-16 lg:mt-28 mb-5 lg:mb-10 text-gray-800`}>
              Key Features
            </SubHeading>
            <div className="mb-10">
              <ul className="list-disc font-normal text-xs lg:text-base 2xl:text-[20px] mx-10 text-justify text-gray-700">
                <li className="mb-4">
                  Showcases the institute’s mission, objectives, and global
                  academic relevance.
                </li>
                <li className="mb-4">
                  Museum and library sections with digitized insights and
                  cultural preservation details.
                </li>
                <li className="mb-4">
                  Event calendar and announcements for conferences, seminars,
                  and publications.
                </li>
                <li className="mb-4">
                  Academic resources including books, bulletins, and research
                  publications.
                </li>
                <li className="mb-4">
                  Integrated gallery for cultural exhibits, manuscripts, and
                  institute events.
                </li>
              </ul>
            </div>

            <SubHeading classes={`mt-16 lg:mt-28 mb-5 lg:mb-10 text-gray-800`}>
              Technology Used
            </SubHeading>
            <div className="flex flex-row items-center gap-10 lg:gap-16 justify-start">
              <div className="flex flex-col items-center w-[85px] lg:w-40 xl:w-44">
                <img
                  src={logoWordpress}
                  alt="WordPress"
                  className="h-12 lg:h-20 object-contain mx-auto"
                />
                <p className="mt-2 text-xs lg:text-sm text-center text-gray-700">
                  WordPress
                </p>
              </div>
              <div className="flex flex-col items-center w-[85px] lg:w-40 xl:w-44">
                <img
                  src={logoElementor}
                  alt="Elementor"
                  className="h-12 lg:h-20 object-contain mx-auto"
                />
                <p className="mt-2 text-xs lg:text-sm text-center text-gray-700">
                  Elementor
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

const ProjectEaglesNestGangtok = () => {
  const bannerEaglesNestRef = useRef();

  const { setFirstDivHeight } = useLogo();

  useEffect(() => {
    if (bannerEaglesNestRef?.current?.offsetHeight > 0) {
      setFirstDivHeight(bannerEaglesNestRef?.current?.offsetHeight);
    }
  }, [bannerEaglesNestRef?.current?.offsetHeight]);

  return (
    <>
      <div>
        <section className="pb-24 lg:pb-36">
          <div className="relative" ref={bannerEaglesNestRef}>
            <div className="bg-black opacity-70 h-72 lg:h-[500px] w-full object-cover absolute"></div>
            <img
              src={eaglesNestBannerPhoto}
              alt="Eagle's Nest Gangtok Banner"
              className="h-72 lg:h-[500px] w-full object-cover"
            />
            <div className="absolute top-1/2 left-10 -translate-y-1/2">
              <Heading classes={`text-white`}>Eagle's Nest Gangtok</Heading>
              <p className="text-white font-medium text-xl lg:text-2xl">
                Premium Homestay Website
              </p>
            </div>
          </div>

          <div className="flex justify-end">
            <a
              href="/our-projects"
              className="text-white text-sm bg-primary px-4 py-2 cursor-pointer hover:underline"
            >
              View All Projects
            </a>
          </div>

          <div className="w-[80%] mx-auto">
            <div className="md:relative flex flex-col md:flex-row justify-center items-center">
              <a
                href="https://eaglesnestgangtok.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Heading classes="mt-10 mb-5 flex justify-center font-medium text-gray-800">
                  Eagle's Nest Gangtok
                </Heading>
              </a>
            </div>

            <div className="mt-10 lg:mt-16 mb-5 lg:mb-10 grid grid-cols-1 lg:grid-cols-2">
              <div className="text-xs lg:text-base 2xl:text-[20px] font-normal mb-10 lg:mb-0 lg:pr-8 text-justify">
                <p className="leading-relaxed text-gray-700">
                  Eagle's Nest Gangtok is a modern homestay website designed to
                  showcase the comfort, serenity, and stunning views offered by
                  this premium staycation destination in Sikkim. Developed with
                  both functionality and aesthetics in mind, the platform
                  highlights room details, amenities, nearby attractions, and
                  booking options for potential guests.
                  <br />
                  <br />
                  The homepage welcomes visitors with high-resolution visuals of
                  the property and its scenic surroundings, while the rest of
                  the site offers user-friendly navigation to explore available
                  rooms, features, and local experiences.
                  <br />
                  <br />
                  The site also includes a gallery, guest testimonials, direct
                  booking inquiries, contact forms, and Google Maps integration
                  to help visitors locate the homestay with ease. The website
                  adapts perfectly to mobile screens, making travel planning
                  seamless from any device.
                </p>
              </div>

              <div className="flex flex-col">
                <div className="relative flex justify-end shadow-2xl">
                  <img
                    src={eaglesNestSS}
                    className="rounded-md h-full"
                    alt="Eagle's Nest Gangtok Website"
                  />
                  <a
                    href="http://eaglesnestgangtok.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="absolute bottom-4 right-6 bg-[#E75124] text-white cursor-pointer px-2 md:px-4 py-1 text-[10px] md:text-sm"
                  >
                    Visit site
                  </a>
                </div>
              </div>
            </div>

            <SubHeading classes={`mt-16 lg:mt-28 mb-5 lg:mb-10 text-gray-800`}>
              Key Features
            </SubHeading>
            <div className="mb-10">
              <ul className="list-disc font-normal text-xs lg:text-base 2xl:text-[20px] mx-10 text-justify text-gray-700">
                <li className="mb-4">
                  Clean homepage with high-impact hero images and property
                  highlights.
                </li>
                <li className="mb-4">
                  Detailed room listings with photos, amenities, and
                  descriptions.
                </li>
                <li className="mb-4">
                  Online booking inquiry form integrated with email
                  notifications.
                </li>
                <li className="mb-4">
                  Mobile-friendly layout for easy access on smartphones and
                  tablets.
                </li>
                <li className="mb-4">
                  Interactive map and embedded reviews from guests to build
                  trust.
                </li>
              </ul>
            </div>

            <SubHeading classes={`mt-16 lg:mt-28 mb-5 lg:mb-10 text-gray-800`}>
              Technology Used
            </SubHeading>
            <div className="flex flex-row items-center gap-10 lg:gap-16 justify-start">
              <div className="flex flex-col items-center w-[85px] lg:w-40 xl:w-44">
                <img
                  src={logoWordpress}
                  alt="WordPress"
                  className="h-12 lg:h-20 object-contain mx-auto"
                />
                <p className="mt-2 text-xs lg:text-sm text-center text-gray-700">
                  WordPress
                </p>
              </div>
              <div className="flex flex-col items-center w-[85px] lg:w-40 xl:w-44">
                <img
                  src={logoElementor}
                  alt="Elementor"
                  className="h-12 lg:h-20 object-contain mx-auto"
                />
                <p className="mt-2 text-xs lg:text-sm text-center text-gray-700">
                  Elementor
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

const ProjectAshiTours = () => {
  const bannerAshiToursPage = useRef();

  const { setFirstDivHeight } = useLogo();

  useEffect(() => {
    if (bannerAshiToursPage?.current?.offsetHeight > 0) {
      setFirstDivHeight(bannerAshiToursPage?.current?.offsetHeight);
    }
  }, [bannerAshiToursPage?.current?.offsetHeight]);

  return (
    <>
      <div>
        <section className="pb-24 lg:pb-36">
          <div className="relative" ref={bannerAshiToursPage}>
            <div className="bg-black opacity-70 h-72 lg:h-[500px] w-full object-cover absolute"></div>
            <img
              src={ashiBannerPhoto}
              alt="Ashi Tours and Travels Banner"
              className="h-72 lg:h-[500px] w-full object-cover"
            />
            <div className="absolute top-1/2 left-10 -translate-y-1/2">
              <Heading classes={`text-white`}>Ashi Tours and Travels</Heading>
              <p className="text-white font-medium text-xl lg:text-2xl">
                Travel & Tour Booking Platform
              </p>
            </div>
          </div>

          <div className="flex justify-end">
            <a
              href="/our-projects"
              className="text-white text-sm bg-primary px-4 py-2 cursor-pointer hover:underline"
            >
              View All Projects
            </a>
          </div>

          <div className="w-[80%] mx-auto">
            <div className="md:relative flex flex-col md:flex-row justify-center items-center">
              <a
                href="https://aashitoursandtravels.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Heading classes="mt-10 mb-5 flex justify-center font-medium text-gray-800">
                  Ashi Tours and Travels
                </Heading>
              </a>
            </div>

            <div className="mt-10 lg:mt-16 mb-5 lg:mb-10 grid grid-cols-1 lg:grid-cols-2">
              <div className="text-xs lg:text-base 2xl:text-[20px] font-normal mb-10 lg:mb-0 lg:pr-8 text-justify">
                <p className="leading-relaxed text-gray-700">
                  Ashi Tours and Travels is a comprehensive travel booking
                  portal offering a curated selection of tour packages across
                  Sikkim and the Northeast region. Built with simplicity and
                  functionality in mind, the platform caters to both domestic
                  and international travelers seeking cultural, adventure, and
                  nature-based experiences.
                  <br />
                  <br />
                  The website provides easy access to package information,
                  itineraries, and booking requests. Visitors can explore
                  different travel themes, check availability, and connect with
                  the Ashi Tours team for personalized travel planning. The
                  portal also features contact forms and interactive elements
                  for quick inquiries.
                  <br />
                  <br />
                  With a clean and responsive layout, the portal supports both
                  desktop and mobile users, ensuring travelers can plan on the
                  go. Tour operators can update offerings and media through a
                  backend dashboard powered by a visual page builder.
                </p>
              </div>

              <div className="flex flex-col">
                <div className="relative flex justify-end shadow-2xl">
                  <img
                    src={aashitatSS}
                    className="rounded-md h-full"
                    alt="Ashi Tours Website"
                  />
                  <a
                    href="https://aashitoursandtravels.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="absolute bottom-4 right-6 bg-[#E75124] text-white cursor-pointer px-2 md:px-4 py-1 text-[10px] md:text-sm"
                  >
                    Visit site
                  </a>
                </div>
              </div>
            </div>

            <SubHeading classes={`mt-16 lg:mt-28 mb-5 lg:mb-10 text-gray-800`}>
              Key Features
            </SubHeading>
            <div className="mb-10">
              <ul className="list-disc font-normal text-xs lg:text-base 2xl:text-[20px] mx-10 text-justify text-gray-700">
                <li className="mb-4">
                  Dynamic listing of multi-day tour packages with details and
                  pricing.
                </li>
                <li className="mb-4">
                  User inquiry and quote request forms linked to email and
                  dashboard.
                </li>
                <li className="mb-4">
                  Responsive design optimized for mobile and desktop browsing.
                </li>
                <li className="mb-4">
                  Admin backend with visual editor for updating content and
                  galleries.
                </li>
                <li className="mb-4">
                  SEO-friendly structure and integration with Google Maps.
                </li>
              </ul>
            </div>

            <SubHeading classes={`mt-16 lg:mt-28 mb-5 lg:mb-10 text-gray-800`}>
              Technology Used
            </SubHeading>
            <div className="flex flex-row items-center gap-10 lg:gap-16 justify-start">
              <div className="flex flex-col items-center w-[85px] lg:w-40 xl:w-44">
                <img
                  src={logoWordpress}
                  alt="WordPress"
                  className="h-12 lg:h-20 object-contain mx-auto"
                />
                <p className="mt-2 text-xs lg:text-sm text-center text-gray-700">
                  WordPress
                </p>
              </div>
              <div className="flex flex-col items-center w-[85px] lg:w-40 xl:w-44">
                <img
                  src={logoElementor}
                  alt="Elementor"
                  className="h-12 lg:h-20 object-contain mx-auto"
                />
                <p className="mt-2 text-xs lg:text-sm text-center text-gray-700">
                  Elementor
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

const ProjectSicunEstore = () => {
  const bannerSicunPage = useRef();

  const { setFirstDivHeight } = useLogo();

  useEffect(() => {
    if (bannerSicunPage?.current?.offsetHeight > 0) {
      setFirstDivHeight(bannerSicunPage?.current?.offsetHeight);
    }
  }, [bannerSicunPage?.current?.offsetHeight]);

  return (
    <>
      <div>
        <section className="pb-24 lg:pb-36">
          <div className="relative" ref={bannerSicunPage}>
            <div className="bg-black opacity-70 h-72 lg:h-[500px] w-full object-cover absolute"></div>
            <img
              src={sicunEstoreBanner}
              alt="SICUN eStore Banner"
              className="h-72 lg:h-[500px] w-full object-cover"
            />
            <div className="absolute top-[50%] lg:top-[40%] -translate-y-2/4 left-10">
              <Heading classes={`text-white -ml-3`}>SICUN eStore</Heading>
              <p className="text-white font-medium text-xl lg:text-2xl ">
                Empowering MPCS through Digital Commerces
              </p>
            </div>
          </div>

          <div className="flex justify-end">
            <a
              href="/our-projects"
              className="text-white text-sm bg-primary px-4 py-2 cursor-pointer hover:underline"
            >
              View All Projects
            </a>
          </div>

          <div className="w-[80%] mx-auto">
            <div className="md:relative flex flex-col md:flex-row justify-center items-center">
              <a
                href="https://store.sicun.org/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Heading className="mt-10 mb-5 flex justify-center font-medium text-gray-800">
                  SICUN eStore Portal
                </Heading>
              </a>
            </div>

            <div className="mt-10 lg:mt-16 mb-5 lg:mb-10 grid grid-cols-1 lg:grid-cols-2">
              <div className="text-xs lg:text-base 2xl:text-[20px] font-normal mb-10 lg:mb-0 lg:pr-8 text-justify">
                <p className="leading-relaxed text-gray-700">
                  The <strong>SICUN eStore</strong> is a digital commerce
                  platform developed to empower Multi-Purpose Cooperative
                  Societies (MPCS) across Sikkim. It enables these grassroots
                  organizations to showcase, market, and sell their locally
                  produced goods online—ranging from organic agricultural
                  products and dairy to handicrafts and processed food items.
                  <br />
                  <br />
                  With this centralized portal, SICUN aims to bridge the
                  rural-urban market gap, create sustainable economic
                  opportunities for MPCS members, and promote self-reliant
                  communities. Each cooperative can manage its own digital
                  storefront, enabling transparency, autonomy, and access to a
                  broader customer base.
                </p>
              </div>

              <div className="flex flex-col">
                <div className="relative flex justify-end shadow-2xl">
                  <img
                    src={sicunEstore}
                    className="rounded-md h-full"
                    alt="SICUN eStore Website"
                  />
                  <a
                    href="https://store.sicun.org/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="absolute bottom-4 right-6 bg-[#E75124] text-white cursor-pointer px-2 md:px-4 py-1 text-[10px] md:text-sm"
                  >
                    Visit site
                  </a>
                </div>
              </div>
            </div>

            <SubHeading classes={`mt-16 lg:mt-28 mb-5 lg:mb-10 text-gray-800`}>
              Key Features
            </SubHeading>
            <div className="mb-10">
              <ul className="list-disc font-normal text-xs lg:text-base 2xl:text-[20px] mx-10 text-justify text-gray-700">
                <li className="mb-4">
                  Individual storefronts for each registered MPCS with product
                  catalogs, pricing, and availability.
                </li>
                <li className="mb-4">
                  Admin dashboard for MPCS to manage orders, inventory, and
                  customer queries independently.
                </li>
                <li className="mb-4">
                  Seamless integration with digital payment gateways for secure
                  online transactions.
                </li>
                <li className="mb-4">
                  Backend content management system (CMS) for SICUN
                  administrators to manage categories, products, and registered
                  cooperatives.
                </li>
                <li className="mb-4">
                  Mobile-responsive design with multilingual support to ensure
                  accessibility across rural regions.
                </li>
              </ul>
            </div>

            <SubHeading classes={`mt-16 lg:mt-28 mb-5 lg:mb-10 text-gray-800`}>
              Technology Used
            </SubHeading>
            <div className="flex flex-row items-center gap-10 lg:gap-16 justify-start">
              <div className="flex flex-col items-center w-[85px] lg:w-40 xl:w-44">
                <img
                  src={logoReactjs}
                  alt="React JS"
                  className="h-12 lg:h-20 object-contain mx-auto"
                  style={{
                    animation: "spin 20s linear infinite",
                  }}
                />
                <p className="mt-2 text-xs lg:text-sm text-center text-gray-700">
                  React JS
                </p>
              </div>
              <div className="flex flex-col items-center w-[85px] lg:w-40 xl:w-44">
                <img
                  src={logoNodejs}
                  alt="Node JS"
                  className="h-12 lg:h-20 object-contain mx-auto"
                />
                <p className="mt-2 text-xs lg:text-sm text-center text-gray-700">
                  Node JS
                </p>
              </div>
              <div className="flex flex-col items-center w-[85px] lg:w-40 xl:w-44">
                <img
                  src={logoPgsql}
                  alt="PostgreSQL"
                  className="h-12 lg:h-20 object-contain mx-auto"
                />
                <p className="mt-2 text-xs lg:text-sm text-center text-gray-700">
                  PostgreSQL
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

const ProjectStnmInventory = () => {
  const bannerInventoryPage = useRef();

  const { setFirstDivHeight } = useLogo();

  useEffect(() => {
    if (bannerInventoryPage?.current?.offsetHeight > 0) {
      setFirstDivHeight(bannerInventoryPage?.current?.offsetHeight);
    }
  }, [bannerInventoryPage?.current?.offsetHeight]);

  return (
    <>
      <div>
        <section className="pb-24 lg:pb-36">
          <div className="relative" ref={bannerInventoryPage}>
            <div className="bg-black opacity-70 h-72 lg:h-[500px] w-full absolute"></div>
            <img
              src={stnmInventorySS1}
              alt="STNM Inventory Management System Banner"
              className="h-72 lg:h-[500px] w-full object-cover"
            />
            <div className="absolute top-1/2 left-10 -translate-y-1/2">
              <Heading classes={`text-white`}>
                STNM Inventory Management
              </Heading>
              <p className="text-white font-medium text-xl lg:text-2xl">
                Real-Time Medical Equipment Status Portal
              </p>
            </div>
          </div>

          <div className="flex justify-end">
            <a
              href="/our-projects"
              className="text-white text-sm bg-primary px-4 py-2 cursor-pointer hover:underline"
            >
              View All Projects
            </a>
          </div>

          <div className="w-[80%] mx-auto">
            <div className="md:relative flex flex-col md:flex-row justify-center items-center">
              <Heading
                classes={`mt-10 mb-5 flex justify-center font-medium text-gray-800`}
              >
                STNM Inventory Management System
              </Heading>
            </div>

            <div className="mt-10 lg:mt-16 mb-5 lg:mb-10 grid grid-cols-1 lg:grid-cols-2">
              <div className="text-xs lg:text-base 2xl:text-[20px] font-normal mb-10 lg:mb-0 lg:pr-8 text-justify">
                <p className="leading-relaxed text-gray-700">
                  The <strong>STNM Hospital Inventory Management System</strong>{" "}
                  is a digital platform created to track, monitor, and manage
                  the status of all critical hospital equipment across
                  departments. It ensures transparency, accountability, and
                  operational readiness of life-saving medical infrastructure.
                  <br />
                  <br />
                  With hundreds of pieces of equipment distributed across wards
                  and operation theaters, this portal allows real-time
                  monitoring of the working condition of machines like:
                </p>
                <ul className="list-disc pl-5 mt-4 text-gray-700">
                  <li>MRI & CT Scan Machines</li>
                  <li>Ventilators and ICU Monitors</li>
                  <li>Dialysis Units</li>
                  <li>Defibrillators & ECG Machines</li>
                  <li>Infusion Pumps, Oximeters, and more</li>
                </ul>
                <p className="mt-4">
                  Equipment is tagged with live status markers:{" "}
                  <strong>Working Fine</strong>, <strong>Standby</strong>,{" "}
                  <strong>Needs Repair</strong>, and{" "}
                  <strong>Not Functional</strong>.
                </p>
              </div>

              <div className="flex flex-col">
                <div className="relative flex justify-end shadow-2xl">
                  <img
                    src={stnmInventorySS2}
                    className="rounded-md h-full"
                    alt="Inventory Dashboard Screenshot"
                  />
                  {/* <a
                    href="" 
                    target="_blank"
                    rel="noopener noreferrer"
                    className="absolute bottom-4 right-6 bg-[#E75124] text-white cursor-pointer px-2 md:px-4 py-1 text-[10px] md:text-sm"
                  >
                    Visit site
                  </a> */}
                </div>
              </div>
            </div>

            <SubHeading classes={`mt-16 lg:mt-28 mb-5 lg:mb-10 text-gray-800`}>
              Core Features
            </SubHeading>
            <div className="mb-10">
              <ul className="list-disc font-normal text-xs lg:text-base 2xl:text-[20px] mx-10 text-justify text-gray-700">
                <li className="mb-4">
                  <strong>Status Dashboard:</strong> Overview of all major
                  medical assets categorized by department and health condition.
                </li>
                <li className="mb-4">
                  <strong>Condition Tagging:</strong> Equipment can be marked as
                  Working, Standby, Under Maintenance, or Not Working.
                </li>
                <li className="mb-4">
                  <strong>QR Code Based Scanning:</strong> Each equipment is
                  mapped with a QR code for real-time verification and scanning.
                </li>
                <li className="mb-4">
                  <strong>Repair Logging:</strong> Request repairs, add
                  comments, and assign to technical staff via the portal.
                </li>
                <li className="mb-4">
                  <strong>Usage History & Analytics:</strong> Track usage
                  frequency, downtime, repair cycles and departmental
                  dependencies.
                </li>
              </ul>
            </div>

            <SubHeading classes={`mt-16 lg:mt-28 mb-5 lg:mb-10 text-gray-800`}>
              Technology Stack
            </SubHeading>
            <div className="flex flex-row items-center gap-10 lg:gap-16 justify-start">
              <div className="flex flex-col items-center w-[85px] lg:w-40 xl:w-44">
                <img
                  src={logoReactjs}
                  alt="React JS"
                  className="h-12 lg:h-20 object-contain mx-auto"
                  style={{
                    animation: "spin 20s linear infinite",
                  }}
                />
                <p className="mt-2 text-xs lg:text-sm text-center text-gray-700">
                  React JS
                </p>
              </div>
              <div className="flex flex-col items-center w-[85px] lg:w-40 xl:w-44">
                <img
                  src={logoNodejs}
                  alt="Node JS"
                  className="h-12 lg:h-20 object-contain mx-auto"
                />
                <p className="mt-2 text-xs lg:text-sm text-center text-gray-700">
                  Node JS
                </p>
              </div>
              <div className="flex flex-col items-center w-[85px] lg:w-40 xl:w-44">
                <img
                  src={logoPgsql}
                  alt="PostgreSQL"
                  className="h-12 lg:h-20 object-contain mx-auto"
                />
                <p className="mt-2 text-xs lg:text-sm text-center text-gray-700">
                  PostgreSQL
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

const ProjectSikkimInfoCommission = () => {
  const bannerSICPage = useRef();

  const { setFirstDivHeight } = useLogo();

  useEffect(() => {
    if (bannerSICPage?.current?.offsetHeight > 0) {
      setFirstDivHeight(bannerSICPage?.current?.offsetHeight);
    }
  }, [bannerSICPage?.current?.offsetHeight]);

  return (
    <>
      <div>
        <section className="pb-24 lg:pb-36">
          <div className="relative" ref={bannerSICPage}>
            <div className="bg-black opacity-70 h-72 lg:h-[500px] w-full object-cover absolute"></div>
            <img
              src={sicBanner}
              alt="Sikkim Information Commission Banner"
              className="h-72 lg:h-[500px] w-full object-cover"
            />
            <div className="absolute top-1/2 left-10 -translate-y-1/2">
              <Heading classes={`text-white`}>
                Sikkim Information Commission
              </Heading>
              <p className="text-white font-medium text-xl lg:text-2xl">
                Government of Sikkim – Official Web Portal
              </p>
            </div>
          </div>

          <div className="flex justify-end">
            <a
              href="/our-projects"
              className="text-white text-sm bg-primary px-4 py-2 cursor-pointer hover:underline"
            >
              View All Projects
            </a>
          </div>

          <div className="w-[80%] mx-auto">
            <div className="md:relative flex flex-col md:flex-row justify-center items-center">
              <a
                href="http://sicsikkim.nic.in/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Heading className="mt-10 mb-5 flex justify-center font-medium text-gray-800">
                  Sikkim Information Commission Website
                </Heading>
              </a>
            </div>

            <div className="mt-10 lg:mt-16 mb-5 lg:mb-10 grid grid-cols-1 lg:grid-cols-2">
              <div className="text-xs lg:text-base 2xl:text-[20px] font-normal mb-10 lg:mb-0 lg:pr-8 text-justify">
                <p className="leading-relaxed text-gray-700">
                  The <strong>Sikkim Information Commission's</strong> primary
                  objective is to promote transparency, accountability, and good
                  governance within the framework of the Government of Sikkim.
                  <br />
                  <br />
                  The official web portal acts as a digital gateway for citizens
                  to interact with the Commission and access key information. It
                  offers a range of services including awareness about RTI
                  processes, guidelines for filing applications, access to
                  decisions and notices, and most importantly—an online RTI
                  e-filing mechanism.
                  <br />
                  <br />
                  Through this e-Governance initiative, the portal empowers
                  individuals to file RTI applications digitally from anywhere,
                  eliminating the need for physical visits and delays in
                  information access.
                </p>
              </div>

              <div className="flex flex-col">
                <div className="relative flex justify-end shadow-2xl">
                  <img
                    src={sicSS}
                    className="rounded-md h-full"
                    alt="Sikkim Information Commission Website"
                  />
                  <a
                    href="http://sicsikkim.nic.in/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="absolute bottom-4 right-6 bg-[#E75124] text-white cursor-pointer px-2 md:px-4 py-1 text-[10px] md:text-sm"
                  >
                    Visit site
                  </a>
                </div>
              </div>
            </div>

            <SubHeading classes={`mt-16 lg:mt-28 mb-5 lg:mb-10 text-gray-800`}>
              Key Features
            </SubHeading>
            <div className="mb-10">
              <ul className="list-disc font-normal text-xs lg:text-base 2xl:text-[20px] mx-10 text-justify text-gray-700">
                <li className="mb-4">
                  <strong>Online RTI e-Filing:</strong> Citizens can file RTI
                  requests online through a secure, user-friendly form, enabling
                  faster response and paperless processing.
                </li>
                <li className="mb-4">
                  <strong>Status Tracking:</strong> Applicants can track the
                  progress of their RTI applications in real-time using their
                  reference number.
                </li>
                <li className="mb-4">
                  <strong>Judgments & Decisions Archive:</strong> Access to all
                  RTI decisions and rulings made by the Commission is available
                  for public reference.
                </li>
                <li className="mb-4">
                  <strong>Guidelines & Resources:</strong> Downloadable manuals,
                  RTI formats, FAQs, and departmental contact details help
                  citizens file effective applications.
                </li>
                <li className="mb-4">
                  <strong>Mobile-Friendly & Accessible:</strong> The portal is
                  optimized for all devices and supports accessible design
                  standards for inclusive usage.
                </li>
              </ul>
            </div>

            <SubHeading classes={`mt-16 lg:mt-28 mb-5 lg:mb-10 text-gray-800`}>
              Technology Used
            </SubHeading>
            <div className="flex flex-row items-center gap-10 lg:gap-16 justify-start">
              <div className="flex flex-col items-center w-[85px] lg:w-40 xl:w-44">
                <img
                  src={logoReactjs}
                  alt="React JS"
                  className="h-12 lg:h-20 object-contain mx-auto"
                  style={{
                    animation: "spin 20s linear infinite",
                  }}
                />
                <p className="mt-2 text-xs lg:text-sm text-center text-gray-700">
                  React JS
                </p>
              </div>
              <div className="flex flex-col items-center w-[85px] lg:w-40 xl:w-44">
                <img
                  src={logoNodejs}
                  alt="Node JS"
                  className="h-12 lg:h-20 object-contain mx-auto"
                />
                <p className="mt-2 text-xs lg:text-sm text-center text-gray-700">
                  Node JS
                </p>
              </div>
              <div className="flex flex-col items-center w-[85px] lg:w-40 xl:w-44">
                <img
                  src={logoPgsql}
                  alt="PostgreSQL"
                  className="h-12 lg:h-20 object-contain mx-auto"
                />
                <p className="mt-2 text-xs lg:text-sm text-center text-gray-700">
                  PostgreSQL
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

const ProjectStnmCms = () => {
  const bannerStnmCmsPage = useRef();

  const { setFirstDivHeight } = useLogo();

  useEffect(() => {
    if (bannerStnmCmsPage?.current?.offsetHeight > 0) {
      setFirstDivHeight(bannerStnmCmsPage?.current?.offsetHeight);
    }
  }, [bannerStnmCmsPage?.current?.offsetHeight]);

  return (
    <>
      <div>
        <section className="pb-24 lg:pb-36">
          <div className="relative" ref={bannerStnmCmsPage}>
            <div className="bg-black opacity-70 h-72 lg:h-[500px] w-full object-cover absolute"></div>
            <img
              src={stnmCmsBannerPhoto}
              alt="STNM Complaint Management"
              className="h-72 lg:h-[500px] w-full object-cover"
            />
            <div className="absolute top-1/2 left-10 -translate-y-1/2">
              <Heading classes={`text-white`}>
                STNM Complaint Management System
              </Heading>
              <p className="text-white font-medium text-xl lg:text-2xl">
                Streamlining Patient Feedback & Redressal
              </p>
            </div>
          </div>

          <div className="flex justify-end">
            <a
              href="/our-projects"
              className="text-white text-sm bg-primary px-4 py-2 cursor-pointer hover:underline"
            >
              View All Projects
            </a>
          </div>

          <div className="w-[80%] mx-auto">
            <div className="md:relative flex flex-col md:flex-row justify-center items-center">
              <Heading
                classes={`mt-10 mb-5 flex justify-center font-medium text-gray-800`}
              >
                STNM Complaint Management System
              </Heading>
            </div>

            <div className="mt-10 lg:mt-16 mb-5 lg:mb-10 grid grid-cols-1 lg:grid-cols-2">
              <div className="text-xs lg:text-base 2xl:text-[20px] font-normal mb-10 lg:mb-0 lg:pr-8 text-justify">
                <p className="leading-relaxed text-gray-700">
                  The STNM Complaint Management System is an internal web-based
                  platform developed to manage, track, and respond to patient
                  complaints and service-related feedback within the STNM
                  Hospital (Sir Thutob Namgyal Memorial Hospital), Gangtok.
                  <br />
                  <br />
                  This platform is designed to enhance transparency,
                  accountability, and service quality by creating a centralized
                  grievance redressal mechanism. Patients and hospital visitors
                  can file complaints through a user-friendly interface, which
                  are then forwarded to the relevant departments for action.
                  <br />
                  <br />
                  Hospital administrators and designated staff have access to a
                  secure backend where complaints can be categorized,
                  prioritized, updated, and resolved efficiently. The system
                  also generates analytical reports for hospital leadership to
                  identify recurring issues, service bottlenecks, and staff
                  responsiveness over time.
                  <br />
                  <br />
                  By digitizing the complaint workflow, the system supports STNM
                  Hospital’s commitment to improved patient care and continuous
                  institutional feedback-based reform.
                </p>
              </div>

              <div className="flex flex-col">
                <div className="relative flex justify-end shadow-2xl">
                  <img
                    src={stnmComplaintSS}
                    className="rounded-md h-full"
                    alt="STNM CMS"
                  />
                  {/* <a
                    href="#"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="absolute bottom-4 right-6 bg-[#E75124] text-white cursor-pointer px-2 md:px-4 py-1 text-[10px] md:text-sm"
                  >
                    Internal Access
                  </a> */}
                </div>
              </div>
            </div>

            <SubHeading classes={`mt-16 lg:mt-28 mb-5 lg:mb-10 text-gray-800`}>
              Key Features
            </SubHeading>
            <div className="mb-10">
              <ul className="list-disc font-normal text-xs lg:text-base 2xl:text-[20px] mx-10 text-justify text-gray-700">
                <li className="mb-4">
                  Online complaint submission portal for patients and visitors.
                </li>
                <li className="mb-4">
                  Role-based access for department heads and administrators to
                  manage complaints.
                </li>
                <li className="mb-4">
                  Automated tracking of complaint statuses – from submission to
                  resolution.
                </li>
                <li className="mb-4">
                  Analytics dashboard to track complaint volume, response times,
                  and resolution trends.
                </li>
                <li className="mb-4">
                  Ability to categorize complaints by department, type, and
                  severity.
                </li>
                <li className="mb-4">
                  Internal notifications for timely escalation of unresolved or
                  sensitive issues.
                </li>
              </ul>
            </div>

            <SubHeading classes={`mt-16 lg:mt-28 mb-5 lg:mb-10 text-gray-800`}>
              Technology Used
            </SubHeading>
            <div className="flex flex-row items-center gap-10 lg:gap-16 justify-start">
              <div className="flex flex-col items-center w-[85px] lg:w-40 xl:w-44">
                <img
                  src={logoReactjs}
                  alt="React JS"
                  className="h-12 lg:h-20 object-contain mx-auto"
                  style={{
                    animation: "spin 20s linear infinite",
                  }}
                />
                <p className="mt-2 text-xs lg:text-sm text-center text-gray-700">
                  React JS
                </p>
              </div>
              <div className="flex flex-col items-center w-[85px] lg:w-40 xl:w-44">
                <img
                  src={logoNodejs}
                  alt="Node JS"
                  className="h-12 lg:h-20 object-contain mx-auto"
                />
                <p className="mt-2 text-xs lg:text-sm text-center text-gray-700">
                  Node JS
                </p>
              </div>
              <div className="flex flex-col items-center w-[85px] lg:w-40 xl:w-44">
                <img
                  src={logoPgsql}
                  alt="PostgreSQL"
                  className="h-12 lg:h-20 object-contain mx-auto"
                />
                <p className="mt-2 text-xs lg:text-sm text-center text-gray-700">
                  PostgreSQL
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

const ProjectStnm = () => {
  const bannerStnmPage = useRef();

  const { setFirstDivHeight } = useLogo();

  useEffect(() => {
    if (bannerStnmPage?.current?.offsetHeight > 0) {
      setFirstDivHeight(bannerStnmPage?.current?.offsetHeight);
    }
  }, [bannerStnmPage?.current?.offsetHeight]);

  return (
    <>
      <div>
        <section className="pb-24 lg:pb-36">
          <div className="relative" ref={bannerStnmPage}>
            <div className="bg-black opacity-70 h-72 lg:h-[500px] w-full object-cover absolute"></div>
            <img
              src={stnmBanner}
              alt="STNM Hospital Banner"
              className="h-72 lg:h-[500px] w-full object-cover"
            />
            <div className="absolute top-1/2 left-10 -translate-y-1/2">
              <Heading classes={`text-white`}>STNM Hospital, Gangtok</Heading>
              <p className="text-white font-medium text-xl lg:text-2xl">
                Official Web Portal – Government of Sikkim
              </p>
            </div>
          </div>

          <div className="flex justify-end">
            <a
              href="/our-projects"
              className="text-white text-sm bg-primary px-4 py-2 cursor-pointer hover:underline"
            >
              View All Projects
            </a>
          </div>

          <div className="w-[80%] mx-auto">
            <div className="md:relative flex flex-col md:flex-row justify-center items-center">
              <a
                href="https://demo.stnmhospital.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Heading className="mt-10 mb-5 flex justify-center font-medium text-gray-800">
                  STNM Hospital Website
                </Heading>
              </a>
            </div>

            <div className="mt-10 lg:mt-16 mb-5 lg:mb-10 grid grid-cols-1 lg:grid-cols-2">
              <div className="text-xs lg:text-base 2xl:text-[20px] font-normal mb-10 lg:mb-0 lg:pr-8 text-justify">
                <p className="leading-relaxed text-gray-700">
                  The official portal of{" "}
                  <strong>Sir Thutob Namgyal Memorial (STNM) Hospital</strong>{" "}
                  serves as a digital health gateway for patients, doctors, and
                  hospital administrators. As one of the most advanced
                  multispeciality public hospitals in Northeast India, STNM aims
                  to offer compassionate, accessible, and technologically
                  enabled healthcare.
                  <br />
                  <br />
                  The portal provides quick access to hospital information,
                  service departments, doctor availability, patient
                  instructions, and digital services like appointment booking
                  and lab result tracking.
                  <br />
                  <br />
                  An ideal hospital, such as STNM, is defined by a blend of
                  medical excellence, modern infrastructure, and
                  patient-centered care. This includes:
                </p>
                <ul className="list-disc pl-5 mt-4 text-gray-700">
                  <li>Qualified and compassionate medical professionals</li>
                  <li>Advanced diagnostic and surgical facilities</li>
                  <li>Hygienic and safe patient wards</li>
                  <li>Emergency and trauma care services</li>
                  <li>Digitally managed OPD/IPD systems</li>
                  <li>Transparency, affordability, and 24x7 availability</li>
                </ul>
              </div>

              <div className="flex flex-col">
                <div className="relative flex justify-end shadow-2xl">
                  <img
                    src={stnmSS}
                    className="rounded-md h-full"
                    alt="STNM Hospital Website"
                  />
                  <a
                    href="https://demo.stnmhospital.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="absolute bottom-4 right-6 bg-[#E75124] text-white cursor-pointer px-2 md:px-4 py-1 text-[10px] md:text-sm"
                  >
                    Visit site
                  </a>
                </div>
              </div>
            </div>

            <SubHeading classes={`mt-16 lg:mt-28 mb-5 lg:mb-10 text-gray-800`}>
              Key Features
            </SubHeading>
            <div className="mb-10">
              <ul className="list-disc font-normal text-xs lg:text-base 2xl:text-[20px] mx-10 text-justify text-gray-700">
                <li className="mb-4">
                  <strong>Online Appointment System:</strong> Patients can
                  schedule appointments with doctors and specialists directly
                  from the website.
                </li>
                <li className="mb-4">
                  <strong>Department Directory:</strong> Complete listing of
                  hospital departments including Cardiology, Orthopedics,
                  Pediatrics, Gynecology, and more.
                </li>
                <li className="mb-4">
                  <strong>Emergency Contacts & Ambulance Info:</strong>{" "}
                  Quick-access emergency details to ensure timely response in
                  critical situations.
                </li>
                <li className="mb-4">
                  <strong>Lab Reports & Diagnostic Access:</strong> Patients can
                  retrieve lab test results online with their patient ID.
                </li>
                <li className="mb-4">
                  <strong>Administrative Notices & Updates:</strong> Real-time
                  publishing of public health advisories, recruitment info,
                  tenders, and events.
                </li>
              </ul>
            </div>

            <SubHeading classes={`mt-16 lg:mt-28 mb-5 lg:mb-10 text-gray-800`}>
              Technology Used
            </SubHeading>
            <div className="flex flex-row items-center gap-10 lg:gap-16 justify-start">
              <div className="flex flex-col items-center w-[85px] lg:w-40 xl:w-44">
                <img
                  src={logoReactjs}
                  alt="React JS"
                  className="h-12 lg:h-20 object-contain mx-auto"
                  style={{
                    animation: "spin 20s linear infinite",
                  }}
                />
                <p className="mt-2 text-xs lg:text-sm text-center text-gray-700">
                  React JS
                </p>
              </div>
              <div className="flex flex-col items-center w-[85px] lg:w-40 xl:w-44">
                <img
                  src={logoNodejs}
                  alt="Node JS"
                  className="h-12 lg:h-20 object-contain mx-auto"
                />
                <p className="mt-2 text-xs lg:text-sm text-center text-gray-700">
                  Node JS
                </p>
              </div>
              <div className="flex flex-col items-center w-[85px] lg:w-40 xl:w-44">
                <img
                  src={logoPgsql}
                  alt="PostgreSQL"
                  className="h-12 lg:h-20 object-contain mx-auto"
                />
                <p className="mt-2 text-xs lg:text-sm text-center text-gray-700">
                  PostgreSQL
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

const ProjectSecSikkim = () => {
  const bannerSecSikkimPage = useRef();

  const { setFirstDivHeight } = useLogo();

  useEffect(() => {
    if (bannerSecSikkimPage?.current?.offsetHeight > 0) {
      setFirstDivHeight(bannerSecSikkimPage?.current?.offsetHeight);
    }
  }, [bannerSecSikkimPage?.current?.offsetHeight]);

  return (
    <>
      <div>
        <section className="pb-24 lg:pb-36">
          <div className="relative" ref={bannerSecSikkimPage}>
            <div className="bg-black opacity-70 h-72 lg:h-[500px] w-full object-cover absolute"></div>
            <img
              src={egovbannerphoto}
              alt="Contact Us photo"
              className="h-72 lg:h-[500px] w-full object-cover"
            />
            <div className="absolute top-1/2 -translate-y-2/4 left-10">
              <Heading classes={`text-white`}>SEC, Sikkim</Heading>
              <p className=" text-white font-medium text-xl lg:text-2xl">
                Website
              </p>
            </div>
          </div>
          <div className="flex justify-end">
            <a
              href="/our-projects"
              className=" text-white text-sm bg-primary  px-4 py-2 cursor-pointer hover:underline"
            >
              View All Projects
            </a>
          </div>
          <div className="w-[80%] mx-auto">
            <div className="md:relative flex flex-col md:flex-row justify-center items-center">
              <a
                href="http://sec.sikkim.gov.in/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Heading className="mt-10 mb-5 flex justify-center text-gray-800">
                  State Election Commission Website
                </Heading>
              </a>

              {/* <div className="mt-0 md:mt-10 mb-0 md:mb-5 md:absolute md:right-0">
                <a
                  href="/our-projects"
                  className="text-white text-[10px] lg:text-sm bg-[#E75124] border px-2 py-1 cursor-pointer rounded-md hover:underline"
                >
                  &lt; Go Back
                </a>
              </div> */}
            </div>
            <div className="mt-10 lg:mt-16 mb-5 lg:mb-10 grid grid-cols-1 lg:grid-cols-2 text-gray-700">
              <div className="text-xs lg:text-base 2xl:text-[20px] font-normal mb-10 lg:mb-0 lg:pr-8 text-justify">
                <p className="leading-relaxed">
                  This is a website for the State Election Commission, Gangtok
                  Sikkim built with an aim to provide essential election related
                  information to the public. It enables public to view
                  notification & circulars from the Government. The website has
                  sophisticated and flexible admin capabilities to easily manage
                  and scrutinize their content prior to it getting published. It
                  has all the facets of a modern website such as screen
                  adaptability for all screen sizes(desktops, laptops, mobile
                  phones & tablets).
                </p>
              </div>
              <div className="flex flex-col">
                <div className="relative flex justify-end shadow-2xl">
                  <img src={websitephotosec} className="rounded-md h-full" />
                  <a
                    href="http://sec.sikkim.gov.in/"
                    target="_blank"
                    className="absolute bottom-4 right-6 bg-[#E75124] text-white cursor-pointer px-2 md:px-4 py-1 text-[10px] md:text-sm"
                  >
                    Visit site
                  </a>
                </div>
                {/* <div className="mt-4 xl:mt-6 flex flex-row md:justify-start lg:justify-end pr-12">
                  <>
                    <div
                      className="rounded-3xl mr-2 lg:mr-4 mb-2 lg:mb-4 font-medium px-1 lg:px-3 py-1 w-[85px] lg:w-40 xl:w-44 text-center text-[10px] lg:text-sm xl:text-lg
                   bg-[#252744] text-white"
                    >
                      ASP.NET
                    </div>
                    <div
                      className="rounded-3xl mr-2 lg:mr-4 mb-2 lg:mb-4 font-medium px-1 lg:px-3 py-1 w-[85px] lg:w-40 xl:w-44 text-center text-[10px] lg:text-sm xl:text-lg
                   bg-[#252744] text-white"
                    >
                      Bootstrap
                    </div>
                    <div
                      className="rounded-3xl mr-2 lg:mr-4 mb-2 lg:mb-4 font-medium px-1 lg:px-3 py-1 w-[85px] lg:w-40 xl:w-44 text-center text-[10px] lg:text-sm xl:text-lg
                   bg-[#252744] text-white"
                    >
                      MS SQL
                    </div>
                  </>
                </div> */}
              </div>
            </div>
            <div className="mt-16 lg:mt-28 mb-5 lg:mb-10 text-base lg:text-2xl font-semibold text-gray-800">
              Features
            </div>
            <div className="mb-10">
              <ul className="list-disc font-normal text-xs lg:text-base 2xl:text-[20px]  mx-10 text-justify text-gray-700">
                <li className="mb-4">
                  It is an informative website providing information related to
                  various aspects like the organization, the rules and
                  guidelines in correspondence to elections held in the state,
                  the list of voters eligible for a particular election, the
                  Panchayati Raj and Municipalities across the state, etc.
                </li>
                <li className="mb-4">
                  Additionally, the website contains a CMS (Content Management
                  System) with login functionality that aids the system
                  administrator in changing the content throughout the entire
                  website.
                </li>
              </ul>
            </div>
            <div className="mt-16 lg:mt-28 mb-5 lg:mb-10 text-base lg:text-2xl font-semibold text-gray-800">
              Technology Used
            </div>
            <div className="flex flex-row items-center gap-10 lg:gap-16 justify-start">
              <div className="flex flex-col items-center w-[85px] lg:w-40 xl:w-44">
                <img
                  src={logoAspnet}
                  alt="ASP.NET"
                  className="h-12 lg:h-20 object-contain mx-auto"
                />
                <p className="mt-2 text-xs lg:text-sm text-center text-gray-700">
                  ASP.NET
                </p>
              </div>
              <div className="flex flex-col items-center w-[85px] lg:w-40 xl:w-44">
                <img
                  src={logoBootstrap}
                  alt="Bootstrap"
                  className="h-12 lg:h-20 object-contain mx-auto"
                />
                <p className="mt-2 text-xs lg:text-sm text-center text-gray-700">
                  Bootstrap
                </p>
              </div>
              <div className="flex flex-col items-center w-[85px] lg:w-40 xl:w-44">
                <img
                  src={logoMsSql}
                  alt="MS SQL"
                  className="h-12 lg:h-20 object-contain mx-auto"
                />
                <p className="mt-2 text-xs lg:text-sm text-center text-gray-700">
                  MS SQL
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

const ProjectSmuPni = () => {
  const [showModal, setShowModal] = useState(false);
  const [clickedImage, setClickedImage] = useState("");

  const bannerSmuPniPage = useRef();

  const { setFirstDivHeight } = useLogo();

  useEffect(() => {
    if (bannerSmuPniPage?.current?.offsetHeight > 0) {
      setFirstDivHeight(bannerSmuPniPage?.current?.offsetHeight);
    }
  }, [bannerSmuPniPage?.current?.offsetHeight]);

  return (
    <>
      <div>
        <section className="pb-24 lg:pb-36">
          <div className="relative" ref={bannerSmuPniPage}>
            <div className="bg-black opacity-70 h-72 lg:h-[500px] w-full object-cover absolute"></div>
            <img
              src={dairybannerphoto}
              alt="Contact Us photo"
              className="h-72 lg:h-[500px] w-full object-cover"
            />
            <div className="absolute top-1/2 -translate-y-2/4 left-10 text-white">
              <div className="flex flex-col justify-center ">
                <Heading classes={`text-white`}>Sikkim Milk Union</Heading>

                <SubHeading classes={"text-white"}>P&I Website</SubHeading>
                <br />
              </div>
              {/* <span className="py-2 md:px-8 bg-primary  text-white   cursor-pointer hover:underline text-center ">
                <a href="https://sikkimilk.coop/" target="_blank">
                  Visit Website
                </a>
              </span> */}
            </div>
          </div>
          <div className="flex justify-end">
            <a
              href="/our-projects"
              className=" text-white text-sm bg-primary  px-4 py-2 cursor-pointer hover:underline"
            >
              View All Projects
            </a>
          </div>
          <div className="w-[80%] mx-auto">
            <div className="md:relative flex flex-col md:flex-row justify-center items-center">
              <Heading classes={`mt-10 mb-5 flex justify-center text-gray-800`}>
                Sikkim Milk Union P&I Website
              </Heading>
            </div>
            {/* <div className="mb-10 text-center underline font-bold text-[12px] md:text-base lg:text-xl text-gray-700">
              We bring you the products from the finest dairy of Sikkim
            </div> */}

            <div className="mt-10 lg:mt-24">
              <p className="mb-4 font-medium text-xs lg:text-base xl:text-[20px] text-gray-800">
                It is the official website for "The Sikkim Co-operative Milk
                Producer's Union Limited". This includes the Procurement and
                Input (P&I) portal that users may access after logging in.
              </p>
              <div className="mb-8 font-normal text-xs lg:text-base xl:text-[20px] text-gray-700">
                <p className="leading-relaxed">
                  Procurement and Input (P&I) is a web-portal which is
                  essentially aimed at automating the milk collection inventory,
                  billing and cooling facilities inventory workflow for Sikkim
                  Milk Cooperative Producer's Union Ltd. The online portal seeks
                  to establish itself as a centralized hub for information to
                  the Sikkim Milk Producers plants in Gangtok & Jorethang
                  regarding daily milk collection, monthly bill generation for
                  society providing the milk, cooling facilities provided to the
                  societies, and many more. It aims to cater to a wide range of
                  stakeholders such as the Plant Administrators, P&I
                  Administrators, Supervisors and Higher Managements of Sikkim
                  Milk Cooperative Producers Union Ltd. Furthermore, it is
                  compatible for viewing in desktops, laptops, tablets & mobile
                  phones. Additionally, this web portal provides its users with
                  all modern reporting capabilities to easily draw inventory or
                  transaction reports in all desired format.
                </p>
              </div>
              <p className="mb-4 font-medium text-xs lg:text-base xl:text-[20px] text-gray-800">
                The Website provides us information regarding:
              </p>
              <ul className="list-disc font-normal text-xs lg:text-base xl:text-[20px] mx-10 mb-8 text-gray-700">
                <li className="mb-4">
                  Profile, Mission, Objectives, Functions, Board of Directors,
                  SMU Executives, Organization Chart and Milestones of Sikkim
                  Milk Union.
                </li>
                <li className="mb-4">
                  Visitors are able to know about the facilities provided to
                  them through Head Office, Regional Plant, Plant and Diary and
                  Co-operative society.
                </li>
                <li className="mb-4">
                  They can also check the product provided to them in products
                  section.
                </li>
                <li className="mb-4">
                  They can contact to the Sikkim Milk Union for further
                  information and queries.
                </li>
              </ul>
              <p className="mb-4 font-medium text-xs lg:text-base xl:text-[20px] text-gray-800">
                A few key features of the P&I portal includes:
              </p>
              <ul className="list-disc font-normal text-xs lg:text-base xl:text-[20px] mx-10 mb-8 text-gray-700">
                <li className="mb-4">
                  User registration for all the stakeholders - System Admin,
                  Society and Members.
                </li>
                <li className="mb-4">
                  Daily Credit/Debit Billing associated with procurement of milk
                  and other products associated with manufacturing from across
                  the state.
                </li>
                <li className="mb-4">
                  Automated billing report generation for a particular time
                  period in diffrent formats as required by the client.
                </li>
                <li className="mb-4">
                  Daily automated SMS notifications in correspondence to the
                  daily operation to all the stakeholders.
                </li>
              </ul>
            </div>

            <SubHeading classes={`mt-16 lg:mt-28 mb-5 lg:mb-10 text-gray-800`}>
              The Website provides us information regarding:
            </SubHeading>

            <ul className="list-disc text-xs lg:text-base 2xl:text-[20px] font-normal mx-10 mb-8 text-gray-700">
              <li className="mb-4">
                Profile, Mission, Objectives, Functions, Board of Directors, SMU
                Executives, Organization Chart and Milestones of Sikkim Milk
                Union.
              </li>
              <li className="mb-4">
                Visitors are able to know about the facilities provided to them
                through Head Office, Regional Plant, Plant and Diary and
                Co-operative society.
              </li>
              <li className="mb-4">
                They can also check the product provided to them in products
                section.
              </li>
              <li className="mb-4">
                They can contact to the Sikkim Milk Union for further
                information and queries.
              </li>
            </ul>

            <SubHeading classes={`mb-5 lg:mb-10 text-gray-800`}>
              Features
            </SubHeading>

            <ul className="list-disc text-xs lg:text-base 2xl:text-[20px] font-normal mx-10 mb-8 text-gray-700">
              <li className="mb-4">
                User registration for all the stakeholders - System Admin,
                Society and Members.
              </li>
              <li className="mb-4">
                Daily Credit/Debit Billing associated with procurement of milk
                and other products assocuated with manufacturing from across the
                state.
              </li>
              <li className="mb-4">
                Automated Billing Report Generation for a particular time period
                in diffrent formats as required by the client.
              </li>
              <li className="mb-4">
                Daily automated SMS notifications in correspondence to the daily
                operation to all the stakeholders.
              </li>
            </ul>

            <SubHeading classes={`pt-6  text-gray-800]`}>
              Some Images of Sikkim Milk Union P&I
            </SubHeading>

            <div className="my-5 flex flex-col md:flex-row items-center gap-16 pt-5 text-gray-700">
              <div
                className="flex flex-col gap-4 cursor-pointer"
                onClick={() => {
                  setShowModal(true);
                  setClickedImage("pni_image1");
                }}
              >
                <img
                  src={projectfirstphoto}
                  alt="projectfirstphoto"
                  className="h-56"
                />

                <span className="text-xs text-center italic">
                  P&I Dashboard
                </span>
              </div>

              <div
                className="flex flex-col gap-2 cursor-pointer"
                onClick={() => {
                  setShowModal(true);
                  setClickedImage("pni_image2");
                }}
              >
                <img
                  src={projectsecondphoto}
                  alt="projectsecondphoto"
                  className="h-56"
                />
                <span className="text-xs text-center italic">
                  Society Configuration of P&I
                </span>
              </div>

              {/* <div
                className="flex flex-col gap-2 cursor-pointer"
                onClick={() => {
                  setShowModal(true);
                  setClickedImage("pni_image3");
                }}
              >
                <img
                  src={projectsecondphoto}
                  alt="projectsecondphoto"
                  className="h-56 "
                />
                <span className="text-xs text-center">projectTHirdphoto</span>
              </div> */}
            </div>

            <SubHeading classes={` mb-5  text-gray-800]`}>
              Technology Used
            </SubHeading>

            <div className="flex flex-row items-center gap-10 lg:gap-16 justify-start my-10">
              <div className="flex flex-col items-center w-[85px] lg:w-40 xl:w-44">
                <img
                  src={logoAspnet}
                  alt="ASP.NET"
                  className="h-12 lg:h-20 object-contain mx-auto"
                />
                <p className="mt-2 text-xs lg:text-sm text-center text-gray-700">
                  ASP.NET
                </p>
              </div>
              <div className="flex flex-col items-center w-[85px] lg:w-40 xl:w-44">
                <img
                  src={logoBootstrap}
                  alt="Bootstrap"
                  className="h-12 lg:h-20 object-contain mx-auto"
                />
                <p className="mt-2 text-xs lg:text-sm text-center text-gray-700">
                  Bootstrap
                </p>
              </div>
              <div className="flex flex-col items-center w-[85px] lg:w-40 xl:w-44">
                <img
                  src={logoMsSql}
                  alt="MS SQL"
                  className="h-12 lg:h-20 object-contain mx-auto"
                />
                <p className="mt-2 text-xs lg:text-sm text-center text-gray-700">
                  MS SQL
                </p>
              </div>
            </div>
          </div>

          <GenericModal
            open={showModal}
            setOpen={setShowModal}
            isAdd={true}
            isLarge={true}
          >
            <div className="my-4">
              {clickedImage === "pni_image1" ? (
                <div className="flex  flex-col justify-center items-center">
                  <div className="flex justify-center w-full relative  ">
                    <p className="text-white text-center">P&I Dashboard</p>
                    <p
                      className=" cursor-pointer text-white absolute right-0 border px-1.5 py-0.5 text-xs  rounded-full "
                      onClick={() => setShowModal(false)}
                    >
                      X
                    </p>
                  </div>

                  <img
                    src={projectfirstphoto}
                    alt="dashboardHRMS"
                    className="h-auto w-full pt-4 object-cover"
                  />
                </div>
              ) : null}

              {clickedImage === "pni_image2" ? (
                <div className="flex  flex-col justify-center items-center">
                  <div className="flex justify-center w-full relative  ">
                    <p className="text-white text-center">
                      Society Configuration of P&I
                    </p>
                    <p
                      className=" cursor-pointer text-white absolute right-0 border px-1.5 py-0.5 text-xs  rounded-full "
                      onClick={() => setShowModal(false)}
                    >
                      X
                    </p>
                  </div>

                  <img
                    src={projectsecondphoto}
                    alt="projectfirstphoto"
                    className="h-auto w-full pt-4 object-cover"
                  />
                </div>
              ) : null}

              {/* {clickedImage === "pni_image3" ? (
                <div className="flex  flex-col justify-center items-center">
                  <div className="flex justify-center w-full relative  ">
                    <p className="text-white text-center">PNI Third Photo</p>
                    <p
                      className=" cursor-pointer text-white absolute right-0 border px-1.5 py-0.5 text-xs  rounded-full "
                      onClick={() => setShowModal(false)}
                    >
                      X
                    </p>
                  </div>

                  <img
                    src={projecthomephoto}
                    alt="projecthomephoto"
                    className="h-full pt-4"
                  />
                </div>
              ) : null} */}
            </div>
          </GenericModal>
        </section>
      </div>
      ;
    </>
  );
};

const ProjectSikkimMilkHRMS = () => {
  const bannerSmuHrmsPage = useRef();

  const { setFirstDivHeight } = useLogo();

  useEffect(() => {
    if (bannerSmuHrmsPage?.current?.offsetHeight > 0) {
      setFirstDivHeight(bannerSmuHrmsPage?.current?.offsetHeight);
    }
  }, [bannerSmuHrmsPage?.current?.offsetHeight]);

  const [showModal, setShowModal] = useState(false);
  const [clickedImage, setClickedImage] = useState("");
  return (
    <>
      <GenericModal
        open={showModal}
        setOpen={setShowModal}
        isAdd={true}
        isLarge={true}
      >
        <div className="my-4 ">
          {clickedImage === "hrms_image1" ? (
            <div className="flex  flex-col justify-between items-center ">
              <div className="flex justify-center w-full relative">
                <p className="text-white text-center">
                  Sikkim Milk Union HRMS Dashboard
                </p>
                <p
                  className=" cursor-pointer text-white absolute right-0 border px-1.5 py-0.5 text-xs  rounded-full "
                  onClick={() => setShowModal(false)}
                >
                  X
                </p>
              </div>

              <img
                src={SmuHrms1}
                alt="dashboardHRMS"
                className="h-full pt-4 w-[900px] "
              />
            </div>
          ) : null}

          {clickedImage === "hrms_image2" ? (
            <div className="flex  flex-col justify-center items-center">
              <div className="flex justify-center w-full relative">
                <p className="text-white text-center">
                  Sikkim Milk Union HRMS Config
                </p>
                <p
                  className=" cursor-pointer text-white absolute right-0 border px-1.5 py-0.5 text-xs  rounded-full "
                  onClick={() => setShowModal(false)}
                >
                  X
                </p>
              </div>

              <img src={SmuHrms2} alt="configHRMS" className="h-full pt-4" />
            </div>
          ) : null}

          {clickedImage === "hrms_image3" ? (
            <div
              className="flex  flex-col justify-center items-center "
              onClick={() => setShowModal(false)}
            >
              <div className="flex justify-center w-full  gap-4 my-3">
                <p className="text-slate-100 text-center font-medium ">
                  Sikkim Milk Union HRMS Config
                </p>
                <p
                  className=" cursor-pointer text-white   border border-white px-1.5 py-0.5 text-xs  rounded-full   "
                  onClick={() => setShowModal(false)}
                >
                  X
                </p>
              </div>

              <img
                src={SmuHrms3}
                alt="login"
                className=" w-full h-full object-cover pt-6"
              />
            </div>
          ) : null}
        </div>
      </GenericModal>

      <div className="relative" ref={bannerSmuHrmsPage}>
        <div className="bg-black bg-opacity-75 h-72 lg:h-[500px] w-full object-cover absolute "></div>
        <img
          src={hrms}
          alt="hrms"
          className="h-72 lg:h-[500px] w-full object-cover"
        />

        <div className="absolute top-[25%]  md:top-[35%] md:left-[5%] flex flex-col justify-center item-center">
          <p className="  text-white font-bold  text-sm md:text-2xl px-4 md:px-0">
            <Heading>Sikkim Milk Union</Heading>
            <SubHeading classes={`text-white`}>
              Human Resource Management System
            </SubHeading>
          </p>
        </div>
      </div>

      <div className="flex justify-end">
        <a
          href="/our-projects"
          className=" text-white text-sm bg-primary  px-4 py-2 cursor-pointer hover:underline"
        >
          View All Projects
        </a>
      </div>

      <div className="w-[75%] mx-auto  pt-2">
        <Heading classes={`mt-10 mb-5 flex justify-center text-gray-800`}>
          Sikkim Milk Union HRMS
        </Heading>

        <div className="mt-10 lg:mt-16 mb-5 lg:mb-10 grid grid-cols-1 lg:grid-cols-2">
          <div className="text-xs lg:text-base 2xl:text-[20px] font-normal mb-10 lg:mb-0 lg:pr-8 text-justify">
            <p className="leading-relaxed text-gray-700">
              This is a Web Portal for the Sikkim Milk Union HRMS with exemplary
              online information and services.The Human Resource Management
              Software of Sikkim Milk Union has following Modules.
            </p>
          </div>
          <div className="flex flex-col">
            <div className="relative flex justify-end shadow-2xl">
              <img src={dashboardHRMS} className="rounded-md h-full" />
            </div>
          </div>
        </div>

        <p className="text-center font-medium text-sm lg:text-base 2xl:text-[20px] pt-4 text-gray-700">
          This is the official Human Resource Management System software for the
          the Sikkim Milk Union HRMS.{" "}
        </p>

        <div className="text-sm lg:text-base 2xl:text-[20px]">
          <p className="pt-6 text-sm lg:text-base 2xl:text-[20px] text-gray-700">
            The Human Resource Management Software of Sikkim Milk Union has the
            following modules.
          </p>
          <h3 className="font-semibold underline underline-offset-1  text-sm lg:text-base 2xl:text-[20px] pt-4 text-gray-800">
            Notifications / Reminders Module:
          </h3>
          <ul className="  text-sm lg:text-base 2xl:text-[20px] pt-4 text-justify text-gray-700">
            <li>
              The system will be able to notify concerned personnel regarding
              important information related with the employee’s career
              progression.
            </li>
            <li className="pt-2">
              For instance, the system will send a notification to the concerned
              personnel if an employee is nearing regularization, if the
              employee is nearing increment, if the employee is nearing
              consolidated pay, if the employee is nearing retirement and other
              vital information regarding the employee’s career progression in
              the organization.
            </li>
          </ul>

          <h3 className="font-semibold underline underline-offset-1 pt-4 text-sm lg:text-base 2xl:text-[20px] text-gray-800">
            Recruitment Module:
          </h3>
          <ul className="  pt-4 text-sm lg:text-base 2xl:text-[20px] text-gray-700">
            <li className="">
              The system will provide a recruitment module where higher
              management can post details regarding various new vacancies
              available in the organisation. Applicants can then fill up the
              recruitment form online itself and submit the same. The
              applications filled can then be viewed and scrutinized by the
              higher management in the system itself.
            </li>
          </ul>

          <h3 className="font-semibold underline underline-offset-1 pt-4 text-gray-800">
            User management Module :
          </h3>
          <ul className="  text-gray-700 ">
            <li className="pt-4">
              The system will provide provisions/flexibility for Sikkim Milk
              Union (SMU) to define and configure user access roles to
              adequately handle important Human Resource functions. The module
              will also enable changes in user access roles in future should
              there be a need to do so..
            </li>
          </ul>

          <h3 className="font-semibold underline underline-offset-1 pt-4 text-gray-800">
            Reports Module:
          </h3>
          <ul className="  pt-1 text-gray-700">
            <li className="pt-1">
              The system will provide various data-driven consolidated reports
              regarding career progression like increments, promotions,
              regularizations, retirements, new recruitments, etc.
            </li>
          </ul>
        </div>

        <p className="font-medium pt-6 italic text-sm lg:text-base 2xl:text-[20px] text-gray-800">
          Images for Sikkim Milk HRMS
        </p>

        <div>
          <div className="my-5 flex flex-col md:flex-row items-center gap-8 pt-5 text-gray-700">
            <div
              className="flex flex-col gap-4 cursor-pointer"
              onClick={() => {
                setShowModal(true);
                setClickedImage("hrms_image1");
              }}
            >
              <img
                src={SmuHrms1}
                alt="dashboardHRMS"
                className="h-40 w-[3/4] "
              />
              <span className="text-sm text-center italic">
                Sikkim Milk Union HRMS Dashboard
              </span>
            </div>

            <div
              className="flex flex-col gap-2 cursor-pointer"
              onClick={() => {
                setShowModal(true);
                setClickedImage("hrms_image2");
              }}
            >
              <img src={SmuHrms2} alt="configHRMS" className="h-44 w-[3/4]" />
              <span className="text-center text-xs italic">
                Sikkim Milk Union HRMS Config
              </span>
            </div>

            <div
              className="flex flex-col gap-2 cursor-pointer"
              onClick={() => {
                setShowModal(true);
                setClickedImage("hrms_image3");
              }}
            >
              <img src={SmuHrms3} alt="configHRMS" className="h-44 w-[3/4]" />
              <span className="text-center text-xs italic">
                Sikkim Milk Union HRMS Reports
              </span>
            </div>

            {/* <div
              className="flex flex-col gap-2 cursor-pointer"
              onClick={() => {
                setShowModal(true);
                setClickedImage("hrms_image3");
              }}
            >
              <img src={smu_hrms} alt="smu_hrms" className="h-44" />
              <span>Sikkim Milk Union HRMS</span>
            </div> */}
          </div>

          <SubHeading classes={`pt-5 mb-5 lg:mb-10 text-gray-800]`}>
            Technology Used
          </SubHeading>

          <div className="flex flex-row items-center gap-10 lg:gap-16 justify-start my-10">
            <div className="flex flex-col items-center w-[85px] lg:w-40 xl:w-44">
              <img
                src={logoReactjs}
                alt="React JS"
                className="h-12 lg:h-20 object-contain mx-auto"
                style={{
                  animation: "spin 20s linear infinite",
                }}
              />
              <p className="mt-2 text-xs lg:text-sm text-center text-gray-700">
                React JS
              </p>
            </div>
            <div className="flex flex-col items-center w-[85px] lg:w-40 xl:w-44">
              <img
                src={logoNodejs}
                alt="Node"
                className="h-12 lg:h-20 object-contain mx-auto"
              />
              <p className="mt-2 text-xs lg:text-sm text-center text-gray-700">
                Node JS
              </p>
            </div>
            <div className="flex flex-col items-center w-[85px] lg:w-40 xl:w-44">
              <img
                src={logoPgsql}
                alt="Postgres"
                className="h-12 lg:h-20 object-contain mx-auto"
              />
              <p className="mt-2 text-xs lg:text-sm text-center text-gray-700">
                PostgreSQL
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const ProjectSikkimMilkMitraApp = () => {
  const bannerSmuMitraPage = useRef();

  const { setFirstDivHeight } = useLogo();

  useEffect(() => {
    if (bannerSmuMitraPage?.current?.offsetHeight > 0) {
      setFirstDivHeight(bannerSmuMitraPage?.current?.offsetHeight);
    }
  }, [bannerSmuMitraPage?.current?.offsetHeight]);

  const [showModal, setShowModal] = useState(false);
  const [clickedImage, setClickedImage] = useState("");
  return (
    <>
      <GenericModal
        open={showModal}
        setOpen={setShowModal}
        isAdd={true}
        isLarge={true}
      >
        <div className="my-10 ">
          {clickedImage === "mitra_app_image1" ? (
            <div
              className="flex  flex-col justify-center items-center "
              onClick={() => setShowModal(false)}
            >
              <div className="flex justify-center w-full  gap-4 my-3">
                <p className="text-slate-100 text-center font-medium ">
                  Sikkim Milk Mitra App Login
                </p>
                <p
                  className=" cursor-pointer text-white   border border-white px-1.5 py-0.5 text-xs  rounded-full   "
                  onClick={() => setShowModal(false)}
                >
                  X
                </p>
              </div>

              <img
                src={appImage}
                alt="login"
                className=" w-auto h-full object-cover pt-6"
              />
            </div>
          ) : null}

          {clickedImage === "mitra_app_image2" ? (
            <div
              className="flex  flex-col justify-center items-center "
              onClick={() => setShowModal(false)}
            >
              <div className="flex justify-center w-full gap-4  my-3 ">
                <p className="text-white text-center">
                  Sikkim Milk Mitra App - Billing
                </p>
                <p
                  className="cursor-pointer text-white   border border-white px-1.5 py-0.5 text-xs  rounded-full  "
                  onClick={() => setShowModal(false)}
                >
                  X
                </p>
              </div>

              <img src={appImage2} alt="billing" className="h-full pt-6" />
            </div>
          ) : null}

          {clickedImage === "mitra_app_image3" ? (
            <div
              className="flex  flex-col justify-center items-center"
              onClick={() => setShowModal(false)}
            >
              <div className="flex justify-center w-full gap-4  my-3 ">
                <p className="text-white text-center">
                  Sikkim Milk Mitra App - Orders
                </p>
                <p
                  className=" cursor-pointer text-white   border border-white px-1.5 py-0.5 text-xs  rounded-full  "
                  onClick={() => setShowModal(false)}
                >
                  X
                </p>
              </div>

              <img src={appImage3} alt="orders" className="h-full pt-6" />
            </div>
          ) : null}

          {clickedImage === "mitra_app_image4" ? (
            <div
              className="flex  flex-col justify-center items-center"
              onClick={() => setShowModal(false)}
            >
              <div className="flex justify-center w-full gap-4  my-3">
                <p className="text-white text-center">
                  Sikkim Milk Mitra App - Registration
                </p>
                <p
                  className=" cursor-pointer text-white   border border-white px-1.5 py-0.5 text-xs  rounded-full  "
                  onClick={() => setShowModal(false)}
                >
                  X
                </p>
              </div>

              <img src={appImage4} alt="orders" className="h-full pt-6" />
            </div>
          ) : null}
        </div>
      </GenericModal>

      <div className="relative" ref={bannerSmuMitraPage}>
        <div className="bg-black opacity-80 h-72 lg:h-[500px] w-full object-cover absolute "></div>
        <img
          src={mitraBanner}
          alt="mitraBanner"
          className="h-72 lg:h-[500px] w-full object-cover"
        />
        <p className="absolute top-1/2 -translate-y-2/4 left-10 text-white">
          <Heading>Sikkim Milk Union</Heading>
          <SubHeading>Mitra App</SubHeading>
        </p>
        <div>
          <span className="px-4  py-1 md:px-12  absolute bottom-[30%] translate-y-1/2 right-[50%] translate-x-1/2  lg:bottom-10 lg:right-[20%] cursor-pointer ">
            <a
              href="https://play.google.com/store/apps/details?id=com.pdmsapp"
              target="_blank"
            >
              <img
                src={googleplay}
                alt="googleplay"
                className="h-8 rounded-lg  "
              />
            </a>
          </span>
        </div>
      </div>
      <div className="flex justify-end">
        <a
          href="/our-projects"
          className=" text-white text-sm bg-primary  px-4 py-2 cursor-pointer hover:underline"
        >
          View All Projects
        </a>
      </div>

      <div className="w-[75%] mx-auto  ">
        <a
          href="https://play.google.com/store/apps/details?id=com.pdmsapp"
          target="_blank"
          rel="noopener noreferrer"
        >
          <Heading className="mt-10 mb-5 flex justify-center text-gray-800">
            Sikkim Milk Union Mitra App
          </Heading>
        </a>

        <div className="mt-10 lg:mt-16 mb-5 lg:mb-10 grid grid-cols-1 lg:grid-cols-2">
          <div className="text-xs lg:text-base 2xl:text-[20px] font-normal mb-10 lg:mb-0 lg:pr-8 text-justify">
            <p className="leading-relaxed text-gray-700">
              An Internet-Based Product Distribution Management solution (Web
              Portal + Mobile App) encompassing all aspects of the organization
              related to Plant operation, Distribution & Marketing. The solution
              combination of a web application typically accessed using a
              desktop browser and a mobile app.
            </p>
          </div>
          <div className="flex flex-col">
            <div className="relative flex justify-end shadow-2xl">
              <img
                src={mitra_Banner}
                className="rounded-md h-full w-auto "
                alt="mitra_app_image"
              />
              <a
                href="https://play.google.com/store/apps/details?id=com.pdmsapp"
                target="_blank"
                className="absolute bottom-4 right-6 bg-[#E75124] text-white cursor-pointer px-2 md:px-4 py-1 text-[10px] md:text-sm"
              >
                Visit App
              </a>
            </div>
          </div>
        </div>

        <SubHeading classes={` pt-5 mb-5 text-gray-800`}>Features</SubHeading>

        <p className="pt-4 text-justify leading-relaxed  md:text-justify text-base 2xl:text-[22px] my-8 mx-4 font-medium text-gray-700">
          An Internet-Based Product Distribution Management solution (Web Portal
          + Mobile App) encompassing all aspects of the organization related to
          Plant operation, Distribution & Marketing. The solution is a
          combination of a web application typically accessed using a desktop
          browser and a mobile app.
          <p className="pt-6 text-base 2xl:text-[22px] font-medium text-gray-800">
            The app will have features such as:
          </p>
        </p>
        <ul className=" list-disc pl-12 text-sm 2xl:text-[20px] text-justify text-gray-700 ">
          <li className="leading-7">
            <span className="font-semibold text-sm 2xl:text-[20px] text-gray-800">
              Online Ordering :
            </span>{" "}
            All Sikkim Milk Union registered agents can order products on a
            daily basis as per their requirement.
          </li>
          <li className="pt-4 leading-7">
            <span className="font-semibold text-sm 2xl:text-[20px] text-gray-800">
              Order history :{" "}
            </span>{" "}
            Agents can view details regarding all the orders they have placed
          </li>
          <li className="pt-4 leading-7">
            <span className="font-semibold text-sm 2xl:text-[20px] text-gray-800">
              Online Payment :{" "}
            </span>{" "}
            Agents after placing the order for Sikkim Milk Products will have a
            provision to make payment online through a dedicated payment
            gateway.
          </li>
          <li className="pt-4 leading-7">
            <span className="font-semibold text-sm 2xl:text-[20px] text-gray-800">
              Wallet Option :{" "}
            </span>
            All registered users now have access to a wallet option, wherein
            refunds or reimbursements from the Sikkim Milk Union will be
            credited, and the wallet's balance will automatically be utilized
            when they place their subsequent orders.
          </li>
          {/* <li className="pt-4">
            <span className="font-semibold text-sm 2xl:text-[20px] text-gray-800">
              Notification
            </span>{" "}
            Pages will be notified regarding orders made (to be decided)
          </li> */}
        </ul>

        <p className="font-medium pt-6 italic text-base 2xl:text-[20px] text-gray-800">
          Images for Sikkim Milk Mitra App
        </p>

        <section>
          <div className="my-5 flex flex-col md:flex-row items-center justify-evenly pt-5 ">
            <div
              className=" flex flex-col gap-4 cursor-pointer  "
              onClick={() => {
                setShowModal(true);
                setClickedImage("mitra_app_image1");
              }}
            >
              <img
                src={appImage}
                alt="login"
                className="w-[300px]  rounded-lg md:h-60 md:w-auto shadow-xl"
              />
              <span className="text-xs italic text-center ">
                Sikkim Milk Mitra App Login
              </span>
            </div>

            <div
              className="flex flex-col gap-4 cursor-pointer"
              onClick={() => {
                setShowModal(true);
                setClickedImage("mitra_app_image2");
              }}
            >
              <img
                src={appImage2}
                alt="billing"
                className="w-[300px] rounded-lg md:h-60 md:w-auto shadow-xl"
              />
              <span className="text-xs italic text-center ">
                Sikkim Milk Mitra App - Billing
              </span>
            </div>
            <div
              className="flex flex-col gap-4 cursor-pointer my-3"
              onClick={() => {
                setShowModal(true);
                setClickedImage("mitra_app_image3");
              }}
            >
              <img
                src={appImage3}
                alt="orders"
                className="w-[300px]  rounded-lg md:h-60 md:w-auto shadow-xl"
              />
              <span className="text-xs italic text-center ">
                Sikkim Milk Mitra App - orders
              </span>
            </div>

            <div
              className="flex flex-col gap-4 cursor-pointer my-4  "
              onClick={() => {
                setShowModal(true);
                setClickedImage("mitra_app_image4");
              }}
            >
              <img
                src={appImage4}
                alt="orders"
                className="w-[300px]  rounded-lg md:h-60 md:w-[150px] shadow-xl"
              />
              <span className="text-xs italic text-center ">
                Sikkim Milk Mitra App - Registration
              </span>
            </div>
          </div>
        </section>

        <SubHeading classes={`  mb-5 text-gray-800]`}>
          Technology Used
        </SubHeading>

        <div className="flex flex-row items-center gap-10 lg:gap-16 justify-start my-10">
          <div className="flex flex-col items-center w-[85px] lg:w-40 xl:w-44">
            <img
              src={logoReactjs}
              alt="React JS"
              className="h-12 lg:h-20 object-contain mx-auto"
              style={{
                animation: "spin 20s linear infinite",
              }}
            />
            <p className="mt-2 text-xs lg:text-sm text-center text-gray-700">
              React Native
            </p>
          </div>
          <div className="flex flex-col items-center w-[85px] lg:w-40 xl:w-44">
            <img
              src={logoNodejs}
              alt="Node JS"
              className="h-12 lg:h-20 object-contain mx-auto"
            />
            <p className="mt-2 text-xs lg:text-sm text-center text-gray-700">
              Node JS
            </p>
          </div>
          <div className="flex flex-col items-center w-[85px] lg:w-40 xl:w-44">
            <img
              src={logoPgsql}
              alt="Postgres JS"
              className="h-12 lg:h-20 object-contain mx-auto"
            />
            <p className="mt-2 text-xs lg:text-sm text-center text-gray-700">
              Postgres JS
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

const ProjectSiscoBank = () => {
  const [showModal, setShowModal] = useState(false);
  const [clickedImage, setClickedImage] = useState("");
  const bannerSiscoPage = useRef();

  const { setFirstDivHeight } = useLogo();

  useEffect(() => {
    if (bannerSiscoPage?.current?.offsetHeight > 0) {
      setFirstDivHeight(bannerSiscoPage?.current?.offsetHeight);
    }
  }, [bannerSiscoPage?.current?.offsetHeight]);

  return (
    <>
      <GenericModal
        open={showModal}
        setOpen={setShowModal}
        isAdd={true}
        isLarge={true}
      >
        <div className="my-4">
          {clickedImage === "sisco_img1" ? (
            <div className="flex  flex-col justify-center items-center">
              <div className="flex justify-center w-full relative  ">
                <p className="text-white text-center"> SISCO Login</p>
                <p
                  className=" cursor-pointer text-white absolute right-0 border px-1.5 py-0.5 text-xs  rounded-full "
                  onClick={() => setShowModal(false)}
                >
                  X
                </p>
              </div>

              <img src={checkrates} alt="checkrates" className="h-full pt-4" />
            </div>
          ) : null}

          {clickedImage === "sisco_img2" ? (
            <div className="flex  flex-col justify-center items-center">
              <div className="flex justify-center w-full relative  ">
                <p className="text-white text-center">SISCO- Dashboard</p>
                <p
                  className=" cursor-pointer text-white absolute right-0 border px-1.5 py-0.5 text-xs  rounded-full "
                  onClick={() => setShowModal(false)}
                >
                  X
                </p>
              </div>

              <img src={findatm} alt="findatm" className="h-full pt-4" />
            </div>
          ) : null}

          {clickedImage === "sisco_img3" ? (
            <div className="flex  flex-col justify-center items-center">
              <div className="flex justify-center w-full relative  ">
                <p className="text-white text-center">SISCO - Dashboard</p>
                <p
                  className=" cursor-pointer text-white absolute right-0 border px-1.5 py-0.5 text-xs  rounded-full "
                  onClick={() => setShowModal(false)}
                >
                  X
                </p>
              </div>

              <img src={loans} alt="loans" className="h-full pt-4" />
            </div>
          ) : null}
        </div>
      </GenericModal>
      <div>
        <section className="pb-24 lg:pb-36">
          <div className="relative" ref={bannerSiscoPage}>
            <div className="bg-black opacity-70 h-72 lg:h-[500px] w-full object-cover absolute"></div>
            <img
              src={bankingbannerphoto2}
              alt="Contact Us photo"
              className="h-72 lg:h-[500px] w-full object-cover"
            />
            <div className="absolute top-1/2 -translate-y-2/4 left-10">
              <Heading classes={`text-white`}>SISCO Bank</Heading>
              <p className=" text-white font-medium text-xl lg:text-2xl">
                Website
              </p>
            </div>
          </div>
          <div className="flex justify-end">
            <a
              href="/our-projects"
              className=" text-white text-sm bg-primary  px-4 py-2 cursor-pointer hover:underline"
            >
              View All Projects
            </a>
          </div>
          <div className="w-[80%] mx-auto">
            <div className="md:relative flex flex-col md:flex-row justify-center items-center">
              <a
                href="https://siscobank.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Heading className="mt-10 mb-5 flex justify-center text-gray-800">
                  SISCO Bank Website
                </Heading>
              </a>

              {/* <div className="mt-0 md:mt-10 mb-0 md:mb-5 md:absolute md:right-0">
                <a
                  href="/our-projects"
                  className="text-white text-[10px] lg:text-sm bg-[#E75124] border px-2 py-1 cursor-pointer rounded-md hover:underline"
                >
                  &lt; Go Back
                </a>
              </div> */}
            </div>
            <div className="mt-10 lg:mt-16 mb-5 lg:mb-10 grid grid-cols-1 lg:grid-cols-2">
              <div className="text-xs lg:text-base 2xl:text-[20px] font-normal mb-10 lg:mb-0 lg:pr-8 text-justify">
                <p className="leading-relaxed text-gray-700">
                  This is a website for Sikkim State Co-operative Bank Pvt Ltd
                  built with an aim to provide essential banking information to
                  its customers and an in-house tool for bank employees to
                  efficiently manage their notification workflow. It enables
                  public to send queries or grievances which in-turn will
                  trigger a notification to all relevant bank administrators to
                  take appropriate action. Also the website has provision for
                  general public to send service request like opening account,
                  credit counselling, request for Cheque book etc. The website
                  has sophisticated and flexible admin capabilities to easily
                  manage and scrutinize their content prior to it getting
                  published. The portal has all the facets of a modern website
                  such as screen adaptability for all screen sizes(desktops,
                  laptops, mobile phones & tablets), Google map integration to
                  easily locate all its branches spread across Sikkim and mail
                  server integration to facilitate sending & receiving of mails
                  from the bank's domain.
                </p>
              </div>
              <div className="flex flex-col">
                <div className="relative flex justify-end shadow-2xl">
                  <img src={websitephotosisco} className="rounded-md h-full" />
                  <a
                    href="https://siscobank.com/"
                    target="_blank"
                    className="absolute bottom-4 right-6 bg-primary text-white cursor-pointer px-2 md:px-4 py-1 text-[10px] md:text-sm"
                  >
                    Visit site
                  </a>
                </div>
                {/* <div className="mt-4 xl:mt-6 flex flex-row md:justify-start lg:justify-end pr-12">
                  <>
                    <div
                      className="rounded-3xl mr-2 lg:mr-4 mb-2 lg:mb-4 font-medium px-1 lg:px-3 py-1 w-[85px] lg:w-40 xl:w-44 text-center text-[10px] lg:text-sm xl:text-lg
                   bg-[#252744] text-white"
                    >
                      React JS
                    </div>
                    <div
                      className="rounded-3xl mr-2 lg:mr-4 mb-2 lg:mb-4 font-medium px-1 lg:px-3 py-1 w-[85px] lg:w-40 xl:w-44 text-center text-[10px] lg:text-sm xl:text-lg
                   bg-[#252744] text-white"
                    >
                      Tailwind CSS
                    </div>
                    <div
                      className="rounded-3xl mr-2 lg:mr-4 mb-2 lg:mb-4 font-medium px-1 lg:px-3 py-1 w-[85px] lg:w-40 xl:w-44 text-center text-[10px] lg:text-sm xl:text-lg
                   bg-[#252744] text-white"
                    >
                      Strapi CMS
                    </div>
                  </>
                </div> */}
              </div>
            </div>
            <SubHeading classes={`mt-16 lg:mt-28 mb-5 lg:mb-10 text-gray-800`}>
              Features
            </SubHeading>
            <div className="mb-10">
              <ul className="list-disc font-normal text-xs lg:text-base 2xl:text-[20px]  mx-10 text-justify text-gray-700">
                <li className="mb-4">
                  The website provides various information about the bank, its
                  history, achievements, stakeholders, annual reports, photo
                  galleries of various events organised by the bank, ATM(s) and
                  Branch(es) location in and around Sikkim, insurance schemes
                  made available by the bank, etc.
                </li>
                <li className="mb-4">
                  The website also provides information about the latest events
                  and happenings asssociated with the bank and the digital
                  banking products and services provided by the bank.
                </li>
                <li className="mb-4">
                  The visitors can send feedback/grievance via request for
                  service for forms to the bank for various purposes.
                </li>
                <li className="mb-4">
                  The visitors can make payments for electricity bills on the
                  website, via links redirected to the corresponding address.
                </li>
                <li className="mb-4">
                  The visitors can also calculate the interests and returns
                  against various fixed and recurring deposits if they plan to
                  open one. They can also calculate the interest amount for
                  various loans provided by the bank.
                </li>
              </ul>
            </div>

            <SubHeading classes={`mt-16 lg:mt-28 mb-5 lg:mb-10 text-gray-800`}>
              Some Images of SISCO Bank Website
            </SubHeading>

            <div className="">
              <div className="my-5 flex flex-col md:flex-row items-center gap-14 pt-5 ">
                <div
                  className=" flex flex-col gap-4 cursor-pointer  "
                  onClick={() => {
                    setShowModal(true);
                    setClickedImage("sisco_img1");
                  }}
                >
                  <img
                    src={checkrates}
                    alt="checkrates"
                    className="h-60 border-2"
                  />
                  <span className="text-xs italic text-center ">
                    Check Rates of SISCO{" "}
                  </span>
                </div>

                <div
                  className="flex flex-col gap-4 cursor-pointer"
                  onClick={() => {
                    setShowModal(true);
                    setClickedImage("sisco_img2");
                  }}
                >
                  <img src={findatm} alt="findatm" className="h-60  border-2" />
                  <span className="text-xs italic text-center ">
                    Find ATM Page of SISCO
                  </span>
                </div>
                <div
                  className="flex flex-col gap-4 cursor-pointer"
                  onClick={() => {
                    setShowModal(true);
                    setClickedImage("sisco_img3");
                  }}
                >
                  <img src={loans} alt="loans" className="h-60 border-2" />
                  <span className="text-xs italic text-center ">
                    {" "}
                    Loan Details Page of SISCO Bank
                  </span>
                </div>
              </div>
            </div>

            <SubHeading classes={`mt-16 lg:mt-28 mb-5 lg:mb-10 text-gray-800`}>
              Technology Used
            </SubHeading>
            <div className="flex flex-row items-center gap-10 lg:gap-16 justify-start my-10">
              <div className="flex flex-col items-center w-[85px] lg:w-40 xl:w-44">
                <img
                  src={logoReactjs}
                  alt="React JS"
                  className="h-12 lg:h-20 object-contain mx-auto"
                  style={{
                    animation: "spin 20s linear infinite",
                  }}
                />
                <p className="mt-2 text-xs lg:text-sm text-center text-gray-700">
                  React JS
                </p>
              </div>
              <div className="flex flex-col items-center w-[85px] lg:w-40 xl:w-44">
                <img
                  src={logoTailwind}
                  alt="Tailwind CSS"
                  className="h-12 lg:h-20 object-contain mx-auto"
                />
                <p className="mt-2 text-xs lg:text-sm text-center text-gray-700">
                  Tailwind CSS
                </p>
              </div>
              <div className="flex flex-col items-center w-[85px] lg:w-40 xl:w-44">
                <img
                  src={logoStrapi}
                  alt="Strapi CMS"
                  className="h-12 lg:h-20 object-contain mx-auto"
                />
                <p className="mt-2 text-xs lg:text-sm text-center text-gray-700">
                  Strapi CMS
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

const ProjectSicun = () => {
  const bannerSicunPage = useRef();

  const { setFirstDivHeight } = useLogo();

  useEffect(() => {
    if (bannerSicunPage?.current?.offsetHeight > 0) {
      setFirstDivHeight(bannerSicunPage?.current?.offsetHeight);
    }
  }, [bannerSicunPage?.current?.offsetHeight]);

  return (
    <>
      <div>
        <section className="pb-24 lg:pb-36">
          <div className="relative" ref={bannerSicunPage}>
            <div className="bg-black opacity-70 h-72 lg:h-[500px] w-full object-cover absolute"></div>
            <img
              src={sicunBanner}
              alt="SICUN Banner"
              className="h-72 lg:h-[500px] w-full object-cover"
            />
            <div className="absolute top-1/2 left-10 -translate-y-1/2">
              <Heading classes={`text-white`}>SICUN</Heading>
              <p className="text-white font-medium text-xl lg:text-2xl">
                Official Website of Sikkim State Cooperative Union
              </p>
            </div>
          </div>

          <div className="flex justify-end">
            <a
              href="/our-projects"
              className="text-white text-sm bg-primary px-4 py-2 cursor-pointer hover:underline"
            >
              View All Projects
            </a>
          </div>

          <div className="w-[80%] mx-auto">
            <div className="md:relative flex flex-col md:flex-row justify-center items-center">
              <a
                href="https://sicun.org"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Heading className="mt-10 mb-5 flex justify-center font-medium text-gray-800">
                  SICUN Website
                </Heading>
              </a>
            </div>

            <div className="mt-10 lg:mt-16 mb-5 lg:mb-10 grid grid-cols-1 lg:grid-cols-2">
              <div className="text-xs lg:text-base 2xl:text-[20px] font-normal mb-10 lg:mb-0 lg:pr-8 text-justify">
                <p className="leading-relaxed text-gray-700">
                  The <strong>Sikkim State Cooperative Union (SICUN)</strong> is
                  the apex body responsible for driving cooperative education,
                  training, and awareness initiatives across the state. Its
                  official web portal,{" "}
                  <a
                    href="https://sicun.org"
                    target="_blank"
                    className="text-blue-600 underline"
                  >
                    sicun.org
                  </a>
                  , serves as a unified digital platform that reflects the core
                  mission of strengthening and supporting the cooperative
                  movement in Sikkim.
                  <br />
                  <br />
                  The site provides a detailed overview of SICUN’s institutional
                  role, infrastructure, leadership board, and training programs.
                  It acts as a knowledge hub for cooperative societies and
                  individuals interested in learning about cooperative
                  governance, entrepreneurship, and policy. Key resources such
                  as registration guidelines, model bye-laws, event notices, and
                  downloadable forms are made available to the public and
                  cooperative stakeholders.
                  <br />
                  <br />
                  Visitors can explore specialized training programs and
                  vocational certification courses in domains like food
                  processing, handicrafts, and skill development. The platform
                  also promotes awareness through event coverage—such as
                  Cooperative Week celebrations, board meetings, and field
                  training sessions. With a strong emphasis on transparency,
                  education, and grassroots empowerment, the portal reinforces
                  SICUN’s long-standing commitment to cooperative values.
                </p>
              </div>

              <div className="flex flex-col">
                <div className="relative flex justify-end shadow-2xl">
                  <img
                    src={websitephotosicun}
                    className="rounded-md h-full"
                    alt="SICUN Website"
                  />
                  <a
                    href="https://sicun.org"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="absolute bottom-4 right-6 bg-[#E75124] text-white cursor-pointer px-2 md:px-4 py-1 text-[10px] md:text-sm"
                  >
                    Visit site
                  </a>
                </div>
              </div>
            </div>

            <SubHeading classes={`mt-16 lg:mt-28 mb-5 lg:mb-10 text-gray-800`}>
              Key Features
            </SubHeading>
            <div className="mb-10">
              <ul className="list-disc font-normal text-xs lg:text-base 2xl:text-[20px] mx-10 text-justify text-gray-700">
                <li className="mb-4">
                  Comprehensive overview of SICUN’s mandate, leadership, and
                  organizational structure.
                </li>
                <li className="mb-4">
                  Access to downloadable model bye-laws, registration forms, and
                  official circulars for cooperative societies.
                </li>
                <li className="mb-4">
                  Real-time updates and notifications on training sessions,
                  board meetings, and cooperative events.
                </li>
                <li className="mb-4">
                  Dedicated section for vocational courses, including
                  certification programs in skill development and food
                  processing.
                </li>
                <li className="mb-4">
                  Event galleries and highlights from field visits, workshops,
                  and Cooperative Week celebrations.
                </li>
                <li className="mb-4">
                  Promotes awareness of cooperative values and ethics through
                  educational content and public engagement.
                </li>
              </ul>
            </div>

            <SubHeading classes={`mt-16 lg:mt-28 mb-5 lg:mb-10 text-gray-800`}>
              Technology Used
            </SubHeading>
            <div className="flex flex-row items-center gap-10 lg:gap-16 justify-start">
              <div className="flex flex-col items-center w-[85px] lg:w-40 xl:w-44">
                <img
                  src={logoReactjs}
                  alt="React JS"
                  className="h-12 lg:h-20 object-contain mx-auto"
                  style={{
                    animation: "spin 20s linear infinite",
                  }}
                />
                <p className="mt-2 text-xs lg:text-sm text-center text-gray-700">
                  React JS
                </p>
              </div>
              <div className="flex flex-col items-center w-[85px] lg:w-40 xl:w-44">
                <img
                  src={logoNodejs}
                  alt="Node JS"
                  className="h-12 lg:h-20 object-contain mx-auto"
                />
                <p className="mt-2 text-xs lg:text-sm text-center text-gray-700">
                  Node JS
                </p>
              </div>
              <div className="flex flex-col items-center w-[85px] lg:w-40 xl:w-44">
                <img
                  src={logoPgsql}
                  alt="PostgreSQL"
                  className="h-12 lg:h-20 object-contain mx-auto"
                />
                <p className="mt-2 text-xs lg:text-sm text-center text-gray-700">
                  PostgreSQL
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

const ProjectSikkimInvestmentSummit = () => {
  const bannerSISPage = useRef();

  const { setFirstDivHeight } = useLogo();

  useEffect(() => {
    if (bannerSISPage?.current?.offsetHeight > 0) {
      setFirstDivHeight(bannerSISPage?.current?.offsetHeight);
    }
  }, [bannerSISPage?.current?.offsetHeight]);

  return (
    <>
      <div>
        <section className="pb-24 lg:pb-36">
          <div className="relative" ref={bannerSISPage}>
            <div className="bg-black opacity-70 h-72 lg:h-[500px] w-full object-cover absolute"></div>
            <img
              src={egovbannerphoto}
              alt="Contact Us photo"
              className="h-72 lg:h-[500px] w-full object-cover"
            />
            <div className="absolute top-1/2 -translate-y-2/4 left-10">
              <Heading classes={`text-white`}>SIS</Heading>
              <p className=" text-white font-medium text-xl lg:text-2xl">
                Website
              </p>
            </div>
          </div>

          <div className="flex justify-end">
            <a
              href="/our-projects"
              className=" text-white text-sm bg-primary  px-4 py-2 cursor-pointer hover:underline"
            >
              View All Projects
            </a>
          </div>
          <div className="w-[80%] mx-auto">
            <div className="md:relative flex flex-col md:flex-row justify-center items-center">
              <a
                href="https://sikkiminvestmentsummit.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Heading className="mt-10 mb-5 flex justify-center text-gray-800">
                  Sikkim Investment Summit Website
                </Heading>
              </a>

              {/* <div className="mt-0 md:mt-10 mb-0 md:mb-5 md:absolute md:right-0">
                <a
                  href="/our-projects"
                  className="text-white text-[10px] lg:text-sm bg-[#E75124] border px-2 py-1 cursor-pointer rounded-md hover:underline"
                >
                  &lt; Go Back
                </a>
              </div> */}
            </div>
            <div className="mt-10 lg:mt-16 mb-5 lg:mb-10 grid grid-cols-1 lg:grid-cols-2">
              <div className="text-xs lg:text-base 2xl:text-[20px] font-normal mb-10 lg:mb-0 lg:pr-8 text-justify">
                <p className="leading-relaxed text-gray-700">
                  This is the official website for Sikkim Investment Summit. The
                  State Government of Sikkim is hosting the 1st edition of the
                  Sikkim Investment Summit (SIS). Sikkim has a long-standing
                  commitment to sustainability and has won global recognition
                  for its sustainable policies. Sikkim has taken measures to
                  promote environmental, social and governance (ESG) issues and
                  stands committed to resolving the present challenges and
                  preparing for the future. The Sikkim Investment Summit will
                  spotlight expert-led conversations with global leaders on
                  climate change, organic farming and innovation around green
                  sustainability. The website is also compatible to all devices
                  i.e. Desktop, Laptop, Tablets & mobile.
                </p>
              </div>
              <div className="flex flex-col">
                <div className="relative flex justify-end shadow-2xl">
                  <img src={websitephotosis} className="rounded-md h-full" />
                  <a
                    href="https://sikkiminvestmentsummit.com/"
                    target="_blank"
                    className="absolute bottom-4 right-6 bg-primary text-white cursor-pointer px-2 md:px-4 py-1 text-[10px] md:text-sm"
                  >
                    Visit site
                  </a>
                </div>
                {/* <div className="mt-4 xl:mt-6 flex flex-row md:justify-start lg:justify-end pr-12">
                  <>
                    <div
                      className="rounded-3xl mr-2 lg:mr-4 mb-2 lg:mb-4 font-medium px-1 lg:px-3 py-1 w-[85px] lg:w-40 xl:w-44 text-center text-[10px] lg:text-sm xl:text-lg
                   bg-[#252744] text-white"
                    >
                      React JS
                    </div>
                    <div
                      className="rounded-3xl mr-2 lg:mr-4 mb-2 lg:mb-4 font-medium px-1 lg:px-3 py-1 w-[85px] lg:w-40 xl:w-44 text-center text-[10px] lg:text-sm xl:text-lg
                   bg-[#252744] text-white"
                    >
                      Node JS
                    </div>
                    <div
                      className="rounded-3xl mr-2 lg:mr-4 mb-2 lg:mb-4 font-medium px-1 lg:px-3 py-1 w-[85px] lg:w-40 xl:w-44 text-center text-[10px] lg:text-sm xl:text-lg
                   bg-[#252744] text-white"
                    >
                      PostgreSQL
                    </div>
                  </>
                </div> */}
              </div>
            </div>
            <SubHeading classes={`mt-16 lg:mt-28 mb-5 lg:mb-10 text-gray-800`}>
              Features
            </SubHeading>
            <div className="mb-10">
              <ul className="list-disc font-medium text-xs lg:text-base xl:text-[20px] mx-10 text-gray-800">
                <li className="mb-4">Modules to be described.</li>
              </ul>
            </div>
            <SubHeading classes={`mt-16 lg:mt-28 mb-5 lg:mb-10 text-gray-800`}>
              Technology Used
            </SubHeading>
            <div className="flex flex-row items-center gap-10 lg:gap-16 justify-start">
              <div className="flex flex-col items-center w-[85px] lg:w-40 xl:w-44">
                <img
                  src={logoReactjs}
                  alt="React JS"
                  className="h-12 lg:h-20 object-contain mx-auto"
                  style={{
                    animation: "spin 20s linear infinite",
                  }}
                />
                <p className="mt-2 text-xs lg:text-sm text-center text-gray-700">
                  React JS
                </p>
              </div>
              <div className="flex flex-col items-center w-[85px] lg:w-40 xl:w-44">
                <img
                  src={logoNodejs}
                  alt="Node JS"
                  className="h-12 lg:h-20 object-contain mx-auto"
                />
                <p className="mt-2 text-xs lg:text-sm text-center text-gray-700">
                  Node JS
                </p>
              </div>
              <div className="flex flex-col items-center w-[85px] lg:w-40 xl:w-44">
                <img
                  src={logoPgsql}
                  alt="PostgreSQL"
                  className="h-12 lg:h-20 object-contain mx-auto"
                />
                <p className="mt-2 text-xs lg:text-sm text-center text-gray-700">
                  PostgreSQL
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

const ProjectSeedCell = () => {
  const bannerSeedCellPage = useRef();

  const { setFirstDivHeight } = useLogo();

  useEffect(() => {
    if (bannerSeedCellPage?.current?.offsetHeight > 0) {
      setFirstDivHeight(bannerSeedCellPage?.current?.offsetHeight);
    }
  }, [bannerSeedCellPage?.current?.offsetHeight]);

  return (
    <>
      <div>
        <section className="pb-24 lg:pb-36">
          <div className="relative" ref={bannerSeedCellPage}>
            <div className="bg-black opacity-70 h-72 lg:h-[500px] w-full object-cover absolute"></div>
            <img
              src={communitybannerphoto}
              alt="Contact Us photo"
              className="h-72 lg:h-[500px] w-full object-cover"
            />
            <div className="absolute top-1/2 left-10 -translate-y-1/2">
              <Heading classes={`text-white`}>SEED Cell</Heading>
              <p className=" text-white font-medium text-xl lg:text-2xl">
                Website
              </p>
            </div>
          </div>
          <div className="flex justify-end">
            <a
              href="/our-projects"
              className=" text-white text-sm bg-primary  px-4 py-2 cursor-pointer hover:underline"
            >
              View All Projects
            </a>
          </div>
          <div className="w-[80%] mx-auto">
            <div className="md:relative flex flex-col md:flex-row justify-center items-center">
              <a
                href="https://sikkimentrepreneur.org/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Heading className="mt-10 mb-5 flex justify-center font-medium text-gray-800">
                  SEED Cell Website
                </Heading>
              </a>

              {/* <div className="mt-0 md:mt-10 mb-0 md:mb-5 md:absolute md:right-0">
                <a
                  href="/our-projects"
                  className="text-white text-[10px] lg:text-sm bg-[#E75124] border px-2 py-1 cursor-pointer rounded-md hover:underline"
                >
                  &lt; Go Back
                </a>
              </div> */}
            </div>
            <div className="mt-10 lg:mt-16 mb-5 lg:mb-10 grid grid-cols-1 lg:grid-cols-2">
              <div className="text-xs lg:text-base 2xl:text-[20px] font-normal mb-10 lg:mb-0 lg:pr-8 text-justify">
                <p className="leading-relaxed text-gray-700">
                  It is the official web portal for Sikkim Entrepreneurship &
                  Economic Development Society where the objective is to build a
                  comprehensive database of all the entrepreneurs in Sikkim.
                  Entrepreneurs (Established or Aspiring) from all over the
                  state can register themselves. The portal will help create a
                  platform in building a sound digital eco-system where
                  entrepreneurs can maintain their business profile to help them
                  achieve business outreach & create community network of fellow
                  entrepreneurs. The web portal will also have features to
                  broadcast all the latest Government backed up schemes
                  available for entrepreneurs (For e.g. SYSS).
                </p>
              </div>
              <div className="flex flex-col">
                <div className="relative flex justify-end shadow-2xl">
                  <img src={websitephotoseed} className="rounded-md h-full" />
                  <a
                    href="https://sikkimentrepreneur.org/"
                    target="_blank"
                    className="absolute bottom-4 right-6 bg-[#E75124] text-white cursor-pointer px-2 md:px-4 py-1 text-[10px] md:text-sm"
                  >
                    Visit site
                  </a>
                </div>
                {/* <div className="mt-4 xl:mt-6 flex flex-row md:justify-start lg:justify-end pr-12">
                  <>
                    <div
                      className="rounded-3xl mr-2 lg:mr-4 mb-2 lg:mb-4 font-medium px-1 lg:px-3 py-1 w-[85px] lg:w-40 xl:w-44 text-center text-[10px] lg:text-sm xl:text-lg
                   bg-[#252744] text-white"
                    >
                      ASP.NET
                    </div>
                    <div
                      className="rounded-3xl mr-2 lg:mr-4 mb-2 lg:mb-4 font-medium px-1 lg:px-3 py-1 w-[85px] lg:w-40 xl:w-44 text-center text-[10px] lg:text-sm xl:text-lg
                   bg-[#252744] text-white"
                    >
                      Bootstrap
                    </div>
                    <div
                      className="rounded-3xl mr-2 lg:mr-4 mb-2 lg:mb-4 font-medium px-1 lg:px-3 py-1 w-[85px] lg:w-40 xl:w-44 text-center text-[10px] lg:text-sm xl:text-lg
                   bg-[#252744] text-white"
                    >
                      MS SQL
                    </div>
                  </>
                </div> */}
              </div>
            </div>
            <SubHeading classes={`mt-16 lg:mt-28 mb-5 lg:mb-10 text-gray-800`}>
              Features
            </SubHeading>
            <div className="mb-10">
              <ul className="list-disc font-normal text-xs lg:text-base 2xl:text-[20px]  mx-10 text-justify text-gray-700">
                <li className="mb-4">
                  The website provides information like Govt. schemes &
                  programs, private sector schemes, Events notification,
                  multilingual support, know-hows, success stories.
                </li>
                <li className="mb-4">
                  The website also a CMS (Content Mangement System) with login
                  which helps the system admin in updating contents throughout
                  the website.
                </li>
                <li className="mb-4">
                  The webite aims at online community building, engagement, and
                  collaboration of the stakeholders through Blogs, online
                  surveys, registrations, complaint redressals, feedbacks &
                  suggestions, entrepreneurship publications, FAQs,
                  highlights/success stories which are facilitated by the
                  website.
                </li>
                <li className="mb-4">
                  The website provides online provisions for capturing key
                  transactions related to the schemes provided by the
                  organization. It has modules like beneficiaries registration
                  and profiling, managing existing beneficiaries, etc.
                </li>
                <li className="mb-4">
                  The website provides various interactive drill-down reports,
                  data visualization components for analytics concerning various
                  aspects.
                </li>
              </ul>
            </div>
            <SubHeading classes={`mt-16 lg:mt-28 mb-5 lg:mb-10 text-gray-800`}>
              Technology Used
            </SubHeading>
            <div className="flex flex-row items-center gap-10 lg:gap-16 justify-start">
              <div className="flex flex-col items-center w-[85px] lg:w-40 xl:w-44">
                <img
                  src={logoAspnet}
                  alt="ASP.NET"
                  className="h-12 lg:h-20 object-contain mx-auto"
                />
                <p className="mt-2 text-xs lg:text-sm text-center text-gray-700">
                  ASP.NET
                </p>
              </div>
              <div className="flex flex-col items-center w-[85px] lg:w-40 xl:w-44">
                <img
                  src={logoBootstrap}
                  alt="Bootstrap"
                  className="h-12 lg:h-20 object-contain mx-auto"
                />
                <p className="mt-2 text-xs lg:text-sm text-center text-gray-700">
                  Bootstrap
                </p>
              </div>
              <div className="flex flex-col items-center w-[85px] lg:w-40 xl:w-44">
                <img
                  src={logoMsSql}
                  alt="MS SQL"
                  className="h-12 lg:h-20 object-contain mx-auto"
                />
                <p className="mt-2 text-xs lg:text-sm text-center text-gray-700">
                  MS SQL
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

const ProjectSabcco = () => {
  const bannerSabccoPage = useRef();

  const { setFirstDivHeight } = useLogo();

  useEffect(() => {
    if (bannerSabccoPage?.current?.offsetHeight > 0) {
      setFirstDivHeight(bannerSabccoPage?.current?.offsetHeight);
    }
  }, [bannerSabccoPage?.current?.offsetHeight]);

  return (
    <>
      <div>
        <section className="pb-24 lg:pb-36">
          <div className="relative" ref={bannerSabccoPage}>
            <div className="bg-black opacity-70 h-72 lg:h-[500px] w-full object-cover absolute"></div>
            <img
              src={bankingbannerphoto}
              alt="banking_photo"
              className="h-72 lg:h-[500px] w-full object-cover"
            />
            <div className="absolute top-1/2 -translate-y-2/4 left-10">
              <Heading classes={`text-white`}>SABCCO</Heading>
              <p className=" text-white font-medium text-xl lg:text-2xl">
                Loan Management System
              </p>
            </div>
          </div>
          <div className="flex justify-end">
            <a
              href="/our-projects"
              className=" text-white text-sm bg-primary  px-4 py-2 cursor-pointer hover:underline"
            >
              View All Projects
            </a>
          </div>
          <div className="w-[80%] mx-auto">
            <div className="md:relative flex flex-col md:flex-row justify-center items-center">
              <a
                href="https://sikkimsabcco.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Heading className="mt-10 mb-5 flex justify-center text-gray-800">
                  SABCCO Loan Management System
                </Heading>
              </a>

              {/* <div className="mt-0 md:mt-10 mb-0 md:mb-5 md:absolute md:right-0">
                <a
                  href="/our-projects"
                  className="text-white text-[10px] lg:text-sm bg-[#E75124] border px-2 py-1 cursor-pointer rounded-md hover:underline"
                >
                  &lt; Go Back
                </a>
              </div> */}
            </div>
            <div className="mt-10 lg:mt-16 mb-5 lg:mb-10 grid grid-cols-1 lg:grid-cols-2">
              <div className="text-xs lg:text-base 2xl:text-[20px] font-normal mb-10 lg:mb-0 lg:pr-8 text-justify">
                <p className="leading-relaxed text-gray-700">
                  An end-to-end online solution in the form of a web application
                  encompassing all aspect of the organization i.e. from public
                  interfaces to automating the entire in-house processes. The
                  portal will have capability to disseminate information and
                  awareness to citizens by providing ‘anytime-anywhere’ access
                  to rich and relevant content about SABCCO’s schemes,
                  objectives, goals and loan related information. The portal
                  shall also have features to enhance, streamline, automate and
                  digitize the back-office processes for increased accuracy,
                  efficiency and remove duplicacy of effort. These include
                  features like applying for loan, login facilities, features to
                  upload images, capabilities for notification and communication
                  etc.
                </p>
              </div>
              <div className="flex flex-col">
                <div className="relative flex justify-end shadow-2xl">
                  <img src={websitephotosabcco} className="rounded-md h-full" />
                  <a
                    href="https://sikkimsabcco.com/"
                    target="_blank"
                    className="absolute bottom-4 right-6 bg-[#E75124] text-white cursor-pointer px-2 md:px-4 py-1 text-[10px] md:text-sm"
                  >
                    Visit site
                  </a>
                </div>
                {/* <div className="mt-4 xl:mt-6 flex flex-row md:justify-start lg:justify-end pr-12">
                  <>
                    <div
                      className="rounded-3xl mr-2 lg:mr-4 mb-2 lg:mb-4 font-medium px-1 lg:px-3 py-1 w-[85px] lg:w-40 xl:w-44 text-center text-[10px] lg:text-sm xl:text-lg
                   bg-[#252744] text-white"
                    >
                      React JS
                    </div>
                    <div
                      className="rounded-3xl mr-2 lg:mr-4 mb-2 lg:mb-4 font-medium px-1 lg:px-3 py-1 w-[85px] lg:w-40 xl:w-44 text-center text-[10px] lg:text-sm xl:text-lg
                   bg-[#252744] text-white"
                    >
                      Node JS
                    </div>
                    <div
                      className="rounded-3xl mr-2 lg:mr-4 mb-2 lg:mb-4 font-medium px-1 lg:px-3 py-1 w-[85px] lg:w-40 xl:w-44 text-center text-[10px] lg:text-sm xl:text-lg
                   bg-[#252744] text-white"
                    >
                      PostgreSQL
                    </div>
                  </>
                </div> */}
              </div>
            </div>
            <SubHeading classes={`mt-16 lg:mt-28 mb-5 lg:mb-10 text-gray-800`}>
              Features
            </SubHeading>
            <div className="mb-10">
              <ul className="list-disc font-medium text-xs lg:text-base 2xl:text-[20px]  mx-10">
                <li className="mb-4 text-gray-700">
                  <span className="font-semibold text-black">
                    Loan Origination:
                  </span>{" "}
                  This feature includes the ability to enter borrower
                  information, loan terms, and loan amount to create a loan
                  application. The system may also support online applications,
                  e-signatures, and document uploads.
                </li>
                <li className="mb-4 text-gray-700">
                  <span className="font-semibold text-black">
                    Loan Servicing:
                  </span>{" "}
                  This feature includes managing loan payments, sending payment
                  reminders, processing late fees, managing escrow accounts, and
                  handling customer service inquiries.
                </li>

                <li className="mb-4 text-gray-700 ">
                  <span className="font-semibold text-black">
                    {" "}
                    Reporting and Analytics:{" "}
                  </span>{" "}
                  This feature includes generating reports and dashboards that
                  provide insight into loan performance, portfolio risk, and
                  profitability. The system should also have the ability to
                  track key performance indicators (KPIs) such as delinquency
                  rates, loan-to-value ratios, and debt-to-income ratios.
                </li>
                <li className="mb-4 text-gray-700">
                  <span className="text-black font-semibold"> Automation:</span>{" "}
                  The system is able to automate routine tasks such as intrest
                  calculation such as simple interest, penal interest ,interest
                  on interest ,one-time-settkement and decree case. And Generte
                  demand Notice.
                </li>
                <li className="mb-4 text-gray-700">
                  <span className="font-semibold text-black">
                    User Experience:
                  </span>{" "}
                  The system have a user-friendly interface, with easy-to-use
                  tools and features that streamline the loan management process
                  for both lenders and borrowers.
                </li>
              </ul>
            </div>
            <SubHeading classes={`mt-16 lg:mt-28 mb-5 lg:mb-10 text-gray-800`}>
              Technology Used
            </SubHeading>
            <div className="flex flex-row items-center gap-10 lg:gap-16 justify-start">
              <div className="flex flex-col items-center w-[85px] lg:w-40 xl:w-44">
                <img
                  src={logoReactjs}
                  alt="React JS"
                  className="h-12 lg:h-20 object-contain mx-auto"
                  style={{
                    animation: "spin 20s linear infinite",
                  }}
                />
                <p className="mt-2 text-xs lg:text-sm text-center text-gray-700">
                  React JS
                </p>
              </div>
              <div className="flex flex-col items-center w-[85px] lg:w-40 xl:w-44">
                <img
                  src={logoNodejs}
                  alt="Node JS"
                  className="h-12 lg:h-20 object-contain mx-auto"
                />
                <p className="mt-2 text-xs lg:text-sm text-center text-gray-700">
                  Node JS
                </p>
              </div>
              <div className="flex flex-col items-center w-[85px] lg:w-40 xl:w-44">
                <img
                  src={logoPgsql}
                  alt="PostgreSQL"
                  className="h-12 lg:h-20 object-contain mx-auto"
                />
                <p className="mt-2 text-xs lg:text-sm text-center text-gray-700">
                  PostgreSQL
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

const ProjectSikkimTourism = () => {
  const bannerSikkimTourismPage = useRef();

  const { setFirstDivHeight } = useLogo();

  useEffect(() => {
    if (bannerSikkimTourismPage?.current?.offsetHeight > 0) {
      setFirstDivHeight(bannerSikkimTourismPage?.current?.offsetHeight);
    }
  }, [bannerSikkimTourismPage?.current?.offsetHeight]);

  const [activeTab, setActiveTab] = useState("cms");
  const [showModal, setShowModal] = useState(false);
  const [clickedImage, setClickedImage] = useState("");
  // bg-[#E75124]
  const activetab = "bg-[#252744] text-white";
  const non_activetab = "bg-[#D9D9D9]";

  const changeTab = (projects) => {
    setActiveTab(projects);
  };

  return (
    <>
      <GenericModal
        open={showModal}
        setOpen={setShowModal}
        // title={"Images of Sikkim Tourism  Content Management  System"}
        isAdd={true}
        isLarge={true}
      >
        <div className="my-4">
          {clickedImage === "tourism_cms_image1" ? (
            <div className="flex  flex-col justify-center items-center">
              <div className="flex justify-center w-full relative  ">
                <p className="text-white text-center">
                  Login Page for Sikkim Tourism
                </p>
                <p
                  className=" cursor-pointer text-white absolute right-0 border px-1.5 py-0.5 text-xs  rounded-full "
                  onClick={() => setShowModal(false)}
                >
                  X
                </p>
              </div>

              <img
                src={tourismLogin}
                alt="loginSikkimTourism"
                className="h-full pt-4"
              />
            </div>
          ) : null}

          {clickedImage === "tourism_cms_image2" ? (
            <div className="flex  flex-col justify-center items-center">
              <div className="flex justify-center w-full relative  ">
                <p className="text-white text-center">
                  Dashboard for Sikkim Tourism
                </p>
                <p
                  className=" cursor-pointer text-white absolute right-0 border px-1.5 py-0.5 text-xs  rounded-full "
                  onClick={() => setShowModal(false)}
                >
                  X
                </p>
              </div>

              <img
                src={dashboardSikkimTourism}
                alt="dashboardSikkimTourism"
                className=" pt-4"
              />
            </div>
          ) : null}

          {clickedImage === "tourism_cms_image3" ? (
            <div className="flex  flex-col justify-center items-center">
              <div className="flex justify-center w-full relative  ">
                <p className="text-white text-center">
                  Data Profiling Sikkim Tourism
                </p>
                <p
                  className=" cursor-pointer text-white absolute right-0 border px-1.5 py-0.5 text-xs  rounded-full "
                  onClick={() => setShowModal(false)}
                >
                  X
                </p>
              </div>

              <img
                src={dataprofiling}
                alt="dataprofiling"
                className="h-full pt-4"
              />
            </div>
          ) : null}
        </div>

        <div className="my-4">
          {clickedImage === "service_registration_image1" ? (
            <div className="flex  flex-col justify-center items-center">
              <div className="flex justify-center w-full relative  ">
                <p className="text-white text-center">Profile Listing</p>
                <p
                  className=" cursor-pointer text-white absolute right-0 border px-1.5 py-0.5 text-xs  rounded-full "
                  onClick={() => setShowModal(false)}
                >
                  X
                </p>
              </div>

              <img src={servicerReg} alt="servicerReg" className=" pt-4 " />
            </div>
          ) : null}

          {clickedImage === "service_registration_image2" ? (
            <div className="flex  flex-col justify-center items-center">
              <div className="flex justify-center w-full relative  ">
                <p className="text-white text-center">
                  Registration From for Sikkim Tourism
                </p>
                <p
                  className=" cursor-pointer text-white absolute right-0 border px-1.5 py-0.5 text-xs  rounded-full "
                  onClick={() => setShowModal(false)}
                >
                  X
                </p>
              </div>

              <img
                src={registrationForm}
                alt="registrationForm"
                className="h-full pt-4"
              />
            </div>
          ) : null}
          {/* 
          {clickedImage === "service_registration_image3" ? (
            <div className="flex  flex-col justify-center items-center">
              <div className="flex justify-center w-full relative  ">
                <p className="text-white text-center">
                  Service Registration for Sikkim Tourism
                </p>
                <p
                  className=" cursor-pointer text-white absolute right-0 border px-1.5 py-0.5 text-xs  rounded-full "
                  onClick={() => setShowModal(false)}
                >
                  X
                </p>
              </div>

              <img
                src={service_registration}
                alt="tourism_cms"
                className="h-full pt-4"
              />
            </div>
          ) : null} */}
        </div>

        <div className="my-4">
          {clickedImage === "travel_card_image1" ? (
            <div className="flex  flex-col justify-center items-center">
              <div className="flex justify-center w-full relative  ">
                <p className="text-white text-center">Page for Travel Card</p>
                <p
                  className=" cursor-pointer text-white absolute right-0 border px-1.5 py-0.5 text-xs  rounded-full "
                  onClick={() => setShowModal(false)}
                >
                  X
                </p>
              </div>

              <img
                src={travelcardpage}
                alt="travelcardpage"
                className="h-full pt-4"
              />
            </div>
          ) : null}

          {clickedImage === "travel_card_image2" ? (
            <div className="flex  flex-col justify-center items-center">
              <div className="flex justify-center w-full relative  ">
                <p className="text-white text-center">
                  Registration form for Travel Card
                </p>
                <p
                  className=" cursor-pointer text-white absolute right-0 border px-1.5 py-0.5 text-xs  rounded-full "
                  onClick={() => setShowModal(false)}
                >
                  X
                </p>
              </div>

              <img src={travelcard} alt="travelcard" className="h-full pt-4" />
            </div>
          ) : null}
          {/* 
          {clickedImage === "travel_card_image3" ? (
            <div className="flex  flex-col justify-center items-center">
              <div className="flex justify-center w-full relative  ">
                <p className="text-white text-center">
                  Service Registration for Sikkim Tourism
                </p>
                <p
                  className=" cursor-pointer text-white absolute right-0 border px-1.5 py-0.5 text-xs  rounded-full "
                  onClick={() => setShowModal(false)}
                >
                  X
                </p>
              </div>

              <img
                src={travel_card}
                alt="tourism_cms"
                className="h-full pt-4"
              />
            </div>
          ) : null} */}
        </div>
      </GenericModal>

      <div className="relative" ref={bannerSikkimTourismPage}>
        <img
          src={SikkimTourismBanner}
          alt="tourism_banner"
          className=" h-72 lg:h-[500px] w-full object-cover"
        />
        <div className="bg-black h-72 lg:h-[500px] w-full object-cover absolute top-0  bg-opacity-75 "></div>
        <div>
          <p className="absolute top-1/2 -translate-y-2/4 left-10 text-white">
            <Heading>Sikkim Tourism </Heading>
            <SubHeading>Web Portal</SubHeading>
          </p>
          <span className="px-4  py-1 md:px-12 bg-primary text-white absolute bottom-[20%] left-10  lg:bottom-4  cursor-pointer hover:underline  ">
            <a href="https://www.sikkimtourism.gov.in/" target="_blank">
              Visit Website
            </a>
          </span>
        </div>
      </div>

      <div className="flex justify-end">
        <a
          href="/our-projects"
          className=" text-white text-sm bg-primary  px-4 py-2 cursor-pointer hover:underline"
        >
          View All Projects
        </a>
      </div>

      <div className="w-[75%] mx-auto   ">
        <a
          href="https://www.sikkimtourism.gov.in/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <Heading className="mt-10 mb-5 flex justify-center text-gray-800">
            Sikkim Tourism Web Portal
          </Heading>
        </a>

        <p className="text-justify md:text-center text-base 2xl:text-[22px] my-8 mx-4 font-medium  text-gray-700 ">
          This is the official Web Portal for the Tourism and Civil Aviation
          department, Government of Sikkim with exemplary online information and
          services. Few of the exclusive feature of the portal includes:
        </p>
      </div>

      <div className="w-[75%] mx-auto text-sm  2xl:text-[20px] pt-4">
        <div className="flex flex-col md:flex-row md:gap-8">
          <span
            className={`${
              activeTab === "cms" ? activetab : non_activetab
            } cursor-pointer px-2 py-2.5 md:px-4 md:py-3 text-center `}
            onClick={() => changeTab("cms")}
          >
            Content Management system
          </span>

          <span
            className={`${
              activeTab === "service registration" ? activetab : non_activetab
            } cursor-pointer px-2 py-2.5 md:px-4 md:py-3 mt-4 md:mt-0 text-center`}
            onClick={() => changeTab("service registration")}
          >
            Service provider registration
          </span>

          <span
            className={`${
              activeTab === "Travel Card" ? activetab : non_activetab
            } cursor-pointer px-2 py-2.5 md:px-4 md:py-3 mt-4  md:mt-0 md:w-[20%] text-center`}
            onClick={() => changeTab("Travel Card")}
          >
            Travel Card
          </span>
        </div>

        {activeTab === "cms" ? (
          <>
            <div className="text-gray-700">
              <h3 className="font-semibold underline mt-10 text-gray-800 ">
                Content Management system to manage the following:
              </h3>
              <ul className="pl-12 list-disc pt-4">
                <li className="leading-7">
                  Destinations – Popular places & attractions
                </li>
                <li className="pt-2 leading-7">
                  Tourism related Notifications & Circulars from the Government.
                </li>
                <li className="pt-2 leading-7">Important links</li>
                <li className="pt-2 leading-7">
                  Things to do – Interests, Activities/Outdoors & Popular
                  itineraries
                </li>
                <li className="pt-2 leading-7">
                  Traveler essentials – Government Affiliations, Entry
                  formalities & Traveller tips
                </li>
                <li className="pt-2 leading-7"> Experience Sikkim</li>
                <li className="pt-2 leading-7">
                  {" "}
                  Service provider details – Entity profiles
                </li>
              </ul>
            </div>
            <p className="pt-8 font-medium underline underline-offset-2 text-gray-800">
              Images of Sikkim Tourism Content Management System
            </p>

            <div>
              <div className="my-5 flex flex-col md:flex-row items-center gap-8 pt-5 ">
                <div
                  className="flex flex-col gap-4 cursor-pointer "
                  onClick={() => {
                    setShowModal(true);
                    setClickedImage("tourism_cms_image1");
                  }}
                >
                  <img
                    src={tourismLogin}
                    alt="loginSikkimTourism"
                    className="h-56 border w-[500px] shadow-2xl"
                  />
                  <span className="text-xs text-center italic">
                    Login Page for Sikkim Tourism
                  </span>
                </div>
                <div
                  className="flex flex-col gap-2 cursor-pointer"
                  onClick={() => {
                    setShowModal(true);
                    setClickedImage("tourism_cms_image2");
                  }}
                >
                  <img
                    src={dashboardSikkimTourism}
                    alt="dashboardSikkimTourism"
                    className="h-56   border shadow-2xl"
                  />
                  <span className="text-xs text-center italic">
                    Dashboard for Sikkim Tourism
                  </span>
                </div>
                <div
                  className="flex flex-col gap-2 cursor-pointer"
                  onClick={() => {
                    setShowModal(true);
                    setClickedImage("tourism_cms_image3");
                  }}
                >
                  <img
                    src={dataprofiling}
                    alt="dataprofiling"
                    className="h-56 shadow-2xl"
                  />
                  <span className="text-xs text-center italic">
                    Data Profiling Sikkim Tourism
                  </span>
                </div>{" "}
                *
              </div>
            </div>
          </>
        ) : null}

        {activeTab === "service registration" ? (
          <>
            <div className="text-gray-700">
              <h3 className="font-semibold underline mt-10 text-gray-800">
                Service provider registration:
              </h3>
              <p className="pt-6 text-justify">
                All Tourism units, accommodation units, travel operators and
                service providers will have the option to register their entity
                in the portal. After online registration, they will receive
                login credentials to the email address used while registration.
                They can then login and edit the following details:
              </p>
              <ul className="pl-8 list-disc pt-4">
                <li className="pt-2">Edit entity profile</li>
                <li className="pt-2">Manage inventory</li>
                <li className="pt-2">Update Media gallery</li>
                <li className="pt-2">
                  Manage room information (For Hotels, Home stays & Lodges)
                </li>
                <li className="pt-2">Daily Tour itinerary management.</li>
              </ul>
            </div>
            <p className="pt-4 font-medium underline underline-offset-2 text-gray-800">
              Images of Sikkim Tourism Service Provider Registration
            </p>

            <div>
              <div className="my-5 flex flex-col md:flex-row items-center gap-8 pt-5">
                <div
                  className="flex flex-col gap-4 cursor-pointer"
                  onClick={() => {
                    setShowModal(true);
                    setClickedImage("service_registration_image1");
                  }}
                >
                  <img
                    src={servicerReg}
                    alt="servicerReg"
                    className="h-56 w-[300px] border shadow-lg"
                  />
                  <span className="text-xs text-center italic">
                    Profile Listing
                  </span>
                </div>

                <div
                  className="flex flex-col gap-2 cursor-pointer"
                  onClick={() => {
                    setShowModal(true);
                    setClickedImage("service_registration_image2");
                  }}
                >
                  <img
                    src={registrationForm}
                    alt="registrationForm"
                    className="h-56 "
                  />
                  <span className="text-xs text-center italic">
                    Registration Form for Sikkim Tourism
                  </span>
                </div>
                {/* <div
                  className="flex flex-col gap-2 cursor-pointer"
                  onClick={() => {
                    setShowModal(true);
                    setClickedImage("service_registration_image3");
                  }}
                >
                  <img
                    src={service_registration}
                    alt="tourism_cms"
                    className="h-56"
                  />
                  <span>Registration Form for Sikkim Tourism</span>
                </div> */}
              </div>
            </div>
          </>
        ) : null}

        {activeTab === "Travel Card" ? (
          <>
            <div className="text-gray-700">
              <h3 className="font-semibold underline mt-10 text-gray-800">
                Travel Card:
              </h3>
              <p className="pt-6 text-justify">
                The Government wanted to have a central repository of data
                concerning Tourists visiting Sikkim after the COVID-19 pandemic
                and that is how Travel card came into picture. Tourists are
                required to fill in requisite details which are as follows:
              </p>
              <ul className="pl-12 list-disc pt-4">
                <li>Personal details</li>
                <li>Tour details</li>
                <li>Additional traveller details</li>
              </ul>
              <p className="pt-4 text-justify">
                After filling all the above-mentioned sections, tourists will
                get a link in the registered mobile number and email address
                wherein they can download the Travel card which has to be
                presented where ever required. The travel card will come with a
                unique 12-digit code (E.g., TO22A0221780) and a QR for the same
                will also be present in the travel card for convenience.
              </p>
            </div>
            <p className="pt-4 font-medium underline underline-offset-2 text-gray-800">
              Images of Sikkim Tourism Travel Card
            </p>
            <div>
              <div className="my-5 flex flex-col md:flex-row items-center gap-8 pt-5 text-gray-700">
                <div
                  className="flex flex-col gap-4 cursor-pointer"
                  onClick={() => {
                    setShowModal(true);
                    setClickedImage("travel_card_image1");
                  }}
                >
                  <img
                    src={travelcardpage}
                    alt="travelcardpage"
                    className="h-56 border shadow-lg "
                  />
                  <span className="text-xs text-center italic">
                    Page for Travel Card
                  </span>
                </div>

                <div
                  className="flex flex-col gap-2 cursor-pointer"
                  onClick={() => {
                    setShowModal(true);
                    setClickedImage("travel_card_image2");
                  }}
                >
                  <img
                    src={travelcard}
                    alt="travelcard"
                    className="h-56 w-3/4 "
                  />
                  <span className="text-xs text-center italic">
                    Registration Form for Travel Card
                  </span>
                </div>

                {/* <div
                  className="flex flex-col gap-2 cursor-pointer"
                  onClick={() => {
                    setShowModal(true);
                    setClickedImage("travel_card_image3");
                  }}
                >
                  <img src={travel_card} alt="tourism_cms" className="h-64" />
                  <span>Registration Form for Sikkim Tourism</span>
                </div> */}
              </div>
            </div>
          </>
        ) : null}

        <SubHeading classes={`  mb-5 text-gray-800]`}>
          Technology Used
        </SubHeading>

        <div className="flex flex-row items-center gap-10 lg:gap-16 justify-start my-10">
          <div className="flex flex-col items-center w-[85px] lg:w-40 xl:w-44">
            <img
              src={logoAspnet}
              alt="ASP.NET"
              className="h-12 lg:h-20 object-contain mx-auto"
            />
            <p className="mt-2 text-xs lg:text-sm text-center text-gray-700">
              ASP.NET
            </p>
          </div>
          <div className="flex flex-col items-center w-[85px] lg:w-40 xl:w-44">
            <img
              src={logoBootstrap}
              alt="Bootstrap"
              className="h-12 lg:h-20 object-contain mx-auto"
            />
            <p className="mt-2 text-xs lg:text-sm text-center text-gray-700">
              Bootstrap
            </p>
          </div>
          <div className="flex flex-col items-center w-[85px] lg:w-40 xl:w-44">
            <img
              src={logoMsSql}
              alt="MS SQL"
              className="h-12 lg:h-20 object-contain mx-auto"
            />
            <p className="mt-2 text-xs lg:text-sm text-center text-gray-700">
              MS SQL
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

const ProjectGratitude = () => {
  const bannerGratitudePage = useRef();

  const { setFirstDivHeight } = useLogo();

  useEffect(() => {
    if (bannerGratitudePage?.current?.offsetHeight > 0) {
      setFirstDivHeight(bannerGratitudePage?.current?.offsetHeight);
    }
  }, [bannerGratitudePage?.current?.offsetHeight]);

  return (
    <>
      <div>
        <section className="pb-24 lg:pb-36">
          <div className="relative" ref={bannerGratitudePage}>
            <div className="bg-black opacity-70 h-72 lg:h-[500px] w-full object-cover absolute"></div>
            <img
              src={ecommercebannerphoto}
              alt="e-Commerce photo"
              className="h-72 lg:h-[500px] w-full object-cover"
            />
            <div className="absolute top-1/2 left-10 -translate-y-1/2">
              <Heading classes={`text-white -ml-3`}>Gratitude</Heading>
              <p className="text-white font-medium text-xl lg:text-2xl ">
                e-Commerce
              </p>
            </div>
          </div>
          <div className="flex justify-end">
            <a
              href="/our-projects"
              className=" text-white text-sm bg-primary  px-4 py-2 cursor-pointer hover:underline"
            >
              View All Projects
            </a>
          </div>
          <div className="w-[80%] mx-auto">
            <div className="md:relative flex flex-col md:flex-row justify-center items-center">
              <a
                href="https://gratitudefg.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Heading classes="mt-10 mb-5 flex justify-center font-medium text-gray-800">
                  GratitudeFG Official Website
                </Heading>
              </a>
            </div>
            <div className="mt-10 lg:mt-16 mb-5 lg:mb-10 grid grid-cols-1 lg:grid-cols-2">
              <div className="text-xs lg:text-base 2xl:text-[20px] font-normal mb-10 lg:mb-0 lg:pr-8 text-justify">
                <p className="leading-relaxed text-gray-700">
                  An E-Commerce website developed for a Local Entrepreneur from
                  Sikkim which is an exclusive platform catering to a wide range
                  of customers with their unique apparels made in Sikkim.
                </p>
              </div>
              <div className="flex flex-col">
                <div className="relative flex justify-end shadow-2xl">
                  <img src={websitephoto} className="rounded-md h-full" />
                  <a
                    href="https://gratitudefg.com/"
                    target="_blank"
                    className="absolute bottom-4 right-6 bg-[#E75124] text-white cursor-pointer px-2 md:px-4 py-1 text-[10px] md:text-sm"
                  >
                    Visit site
                  </a>
                </div>
              </div>
            </div>

            <div className="flex flex-col gap-y-10">
              <SubHeading classes={`mt-16 lg:mt-28 text-gray-800`}>
                Snapshots
              </SubHeading>
              <img src={websitephoto2} className="rounded-md border" />
              <img src={websitephoto3} className="rounded-md border" />
            </div>

            <SubHeading classes={`mt-16 lg:mt-28 mb-5 lg:mb-10 text-gray-800`}>
              Features
            </SubHeading>
            <div className="mb-10">
              <ul className="list-disc font-normal text-xs lg:text-base 2xl:text-[20px]  mx-10 text-justify text-gray-700">
                <li className="mb-4">User-Friendly Interface</li>
                <li className="mb-4">Online Ordering</li>
                <li className="mb-4">Customizable Storefronts</li>
                <li className="mb-4">Secure Payment Gateway</li>
                <li className="mb-4">Inventory Management</li>
                <li className="mb-4">Marketing and SEO Tools</li>
                <li className="mb-4">Device Responsiveness</li>
              </ul>
            </div>
            <SubHeading classes={`mt-16 lg:mt-28 mb-5 lg:mb-10 text-gray-800`}>
              Technology Used
            </SubHeading>
            <div className="flex flex-row items-center gap-10 lg:gap-16 justify-start">
              <div className="flex flex-col items-center w-[85px] lg:w-40 xl:w-44">
                <img
                  src={logoReactjs}
                  alt="React JS"
                  className="h-12 lg:h-20 object-contain mx-auto"
                  style={{
                    animation: "spin 20s linear infinite",
                  }}
                />

                <p className="mt-2 text-xs lg:text-sm text-center text-gray-700">
                  React JS
                </p>
              </div>
              <div className="flex flex-col items-center w-[85px] lg:w-40 xl:w-44">
                <img
                  src={logoNodejs}
                  alt="Node JS"
                  className="h-12 lg:h-20 object-contain mx-auto"
                />
                <p className="mt-2 text-xs lg:text-sm text-center text-gray-700">
                  Node JS
                </p>
              </div>
              <div className="flex flex-col items-center w-[85px] lg:w-40 xl:w-44">
                <img
                  src={logoPgsql}
                  alt="PostgreSQL"
                  className="h-12 lg:h-20 object-contain mx-auto"
                />
                <p className="mt-2 text-xs lg:text-sm text-center text-gray-700">
                  PostgreSQL
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

const ProjectRsb = () => {
  const bannerRsbPage = useRef();

  const { setFirstDivHeight } = useLogo();

  useEffect(() => {
    if (bannerRsbPage?.current?.offsetHeight > 0) {
      setFirstDivHeight(bannerRsbPage?.current?.offsetHeight);
    }
  }, [bannerRsbPage?.current?.offsetHeight]);

  return (
    <>
      <div>
        <section className="pb-24 lg:pb-36">
          <div className="relative" ref={bannerRsbPage}>
            <div className="bg-black opacity-70 h-72 lg:h-[500px] w-full object-cover absolute"></div>
            <img
              src={egovbannerphoto}
              alt="Contact Us photo"
              className="h-72 lg:h-[500px] w-full object-cover"
            />
            <div className="absolute top-1/2 -translate-y-2/4 left-10">
              <Heading classes={`text-white`}>Rajya Sainik Board</Heading>
              <p className=" text-white font-medium text-xl lg:text-2xl">
                Website
              </p>
            </div>
          </div>
          <div className="flex justify-end">
            <a
              href="/our-projects"
              className=" text-white text-sm bg-primary  px-4 py-2 cursor-pointer hover:underline"
            >
              View All Projects
            </a>
          </div>
          <div className="w-[80%] mx-auto">
            <div className="md:relative flex flex-col md:flex-row justify-center items-center">
              <a
                href="http://www.deswsikkim.nic.in/Public/Index/Home"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Heading className="mt-10 mb-5 flex justify-center text-gray-800">
                  Rajya Sainik Board Website
                </Heading>
              </a>

              {/* <div className="mt-0 md:mt-10 mb-0 md:mb-5 md:absolute md:right-0">
                <a
                  href="/our-projects"
                  className="text-white text-[10px] lg:text-sm bg-[#E75124] border px-2 py-1 cursor-pointer rounded-md hover:underline"
                >
                  &lt; Go Back
                </a>
              </div> */}
            </div>
            <div className="mt-10 lg:mt-16 mb-5 lg:mb-10 grid grid-cols-1 lg:grid-cols-2">
              <div className="text-xs lg:text-base 2xl:text-[20px] font-normal mb-10 lg:mb-0 lg:pr-8 text-justify">
                <p className="leading-relaxed text-gray-700">
                  This is a dynamic website for the Department of Sainik Welfare
                  (Govt. of Sikkim) that houses all information regarding state
                  Sainik welfare and other army related activities. The website
                  aims to become a centralized platform for information
                  dissemination regarding various information, activities,
                  schemes with respect to the department. It aims to cater to
                  wide range of stakeholders such as Central Government, State
                  Govt., defense personnel, civilians and ex-servicemen. The
                  portal is developed with standards as prescribed by the Govt.
                  of India and is compatible to all modern browsers. It is
                  powered by a customized CMS(content management system) that
                  enables the administrator to easily & efficiently manage its
                  content. Furthermore, it is compatible for viewing in both
                  laptops, mobile phones & tablets and has login capabilities
                  for department administrators to manage content as well as for
                  ex-servicemen to log their grievances.
                </p>
              </div>
              <div className="flex flex-col">
                <div className="relative flex justify-end shadow-2xl">
                  <img src={rsbSS} className="rounded-md h-full" />
                  <a
                    href="http://www.deswsikkim.nic.in/Public/Index/Home"
                    target="_blank"
                    className="absolute bottom-4 right-6 bg-primary text-white cursor-pointer px-2 md:px-4 py-1 text-[10px] md:text-sm"
                  >
                    Visit site
                  </a>
                </div>
                {/* <div className="mt-4 xl:mt-6 flex flex-row md:justify-start lg:justify-end pr-12">
                  <>
                    <div
                      className="rounded-3xl mr-2 lg:mr-4 mb-2 lg:mb-4 font-medium px-1 lg:px-3 py-1 w-[85px] lg:w-40 xl:w-44 text-center text-[10px] lg:text-sm xl:text-lg
                   bg-[#252744] text-white"
                    >
                      ASP.NET
                    </div>
                    <div
                      className="rounded-3xl mr-2 lg:mr-4 mb-2 lg:mb-4 font-medium px-1 lg:px-3 py-1 w-[85px] lg:w-40 xl:w-44 text-center text-[10px] lg:text-sm xl:text-lg
                   bg-[#252744] text-white"
                    >
                      Bootstrap
                    </div>
                    <div
                      className="rounded-3xl mr-2 lg:mr-4 mb-2 lg:mb-4 font-medium px-1 lg:px-3 py-1 w-[85px] lg:w-40 xl:w-44 text-center text-[10px] lg:text-sm xl:text-lg
                   bg-[#252744] text-white"
                    >
                      MS SQL
                    </div>
                  </>
                </div> */}
              </div>
            </div>
            <SubHeading classes={`mt-16 lg:mt-28 mb-5 lg:mb-10 text-gray-800`}>
              Features
            </SubHeading>
            <div className="mb-10">
              <ul className="list-disc font-normal text-xs lg:text-base 2xl:text-[20px]  mx-10 text-justify text-gray-700">
                <li className="mb-4">
                  It is primarily an informative website providing information
                  related to various aspects like who the actual target audience
                  is, about the organization, its history, the gallantry award
                  winners from Sikkim.
                </li>
                <li className="mb-4">
                  The website also provides information about the various grants
                  and schemes that can be availed by the target audience,
                  recruitment notifications in civil defence, the board
                  meetings, events and activities organized by RSB, the location
                  of sainik houses/boards in the state.
                </li>
                <li className="mb-4">
                  The website also has a CMS (Content Mangement System) with
                  login which helps the system admin in updating contents
                  throughout the website.
                </li>
                <li className="mb-4">
                  The website visitors can submit feedback and queries via the
                  feedback form present in the website.
                </li>
                <li className="mb-4">
                  The website visitors can also register themselves as
                  applicants, if they meet the registration criteria, so as to
                  avail the services provided to them by the board.
                </li>
              </ul>
            </div>
            <SubHeading classes={`mt-16 lg:mt-28 mb-5 lg:mb-10 text-gray-800`}>
              Technology Used
            </SubHeading>
            <div className="flex flex-row items-center gap-10 lg:gap-16 justify-start">
              <div className="flex flex-col items-center w-[85px] lg:w-40 xl:w-44">
                <img
                  src={logoAspnet}
                  alt="ASP.NET"
                  className="h-12 lg:h-20 object-contain mx-auto"
                />
                <p className="mt-2 text-xs lg:text-sm text-center text-gray-700">
                  ASP.NET
                </p>
              </div>
              <div className="flex flex-col items-center w-[85px] lg:w-40 xl:w-44">
                <img
                  src={logoBootstrap}
                  alt="Bootstrap"
                  className="h-12 lg:h-20 object-contain mx-auto"
                />
                <p className="mt-2 text-xs lg:text-sm text-center text-gray-700">
                  Bootstrap
                </p>
              </div>
              <div className="flex flex-col items-center w-[85px] lg:w-40 xl:w-44">
                <img
                  src={logoMsSql}
                  alt="MS SQL"
                  className="h-12 lg:h-20 object-contain mx-auto"
                />
                <p className="mt-2 text-xs lg:text-sm text-center text-gray-700">
                  MS SQL
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};
